/* @ds-bundle: {"format":4,"namespace":"SocietyBrandsDesignSystem_019e27","components":[{"name":"Badge","sourcePath":"components/Badge.jsx"},{"name":"Button","sourcePath":"components/Button.jsx"},{"name":"Card","sourcePath":"components/Card.jsx"},{"name":"SectionHeading","sourcePath":"components/SectionHeading.jsx"}],"sourceHashes":{"components/Badge.jsx":"709ae945d161","components/Button.jsx":"591ec47f0660","components/Card.jsx":"dd96dea302a3","components/SectionHeading.jsx":"6e19e65cb76d","slides/deck-stage.js":"5e65f78ba7d6","ui_kits/website/App.jsx":"4b9ae11061ed","ui_kits/website/BrandCard.jsx":"25b2e96fc237","ui_kits/website/BrandGrid.jsx":"cf49912841ae","ui_kits/website/BrandsPage.jsx":"c03bac433b25","ui_kits/website/CertBadges.jsx":"a99924b8fa7f","ui_kits/website/Footer.jsx":"97a9f4e2df8a","ui_kits/website/Header.jsx":"33fa466a6ad1","ui_kits/website/Hero.jsx":"97cf95040b72","ui_kits/website/InOnAroundSection.jsx":"5bd7a264bd3c","ui_kits/website/LocationsMarquee.jsx":"2ce902342a52","ui_kits/website/MissionFeature.jsx":"b3b39ac97423","ui_kits/website/PartnerPage.jsx":"91ce9a846d73","ui_kits/website/PressStrip.jsx":"7e4d37645e04","ui_kits/website/PromiseSection.jsx":"8ac90899aa45"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.SocietyBrandsDesignSystem_019e27 = window.SocietyBrandsDesignSystem_019e27 || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/Badge.jsx
try { (() => {
const badgeTones = {
  plant: {
    background: 'var(--sb-plant)',
    color: 'var(--sb-ivory)',
    border: '1px solid transparent'
  },
  soil: {
    background: 'var(--sb-soil)',
    color: 'var(--sb-ivory)',
    border: '1px solid transparent'
  },
  sand: {
    background: 'var(--sb-sand)',
    color: 'var(--sb-soil)',
    border: '1px solid transparent'
  },
  outline: {
    background: 'transparent',
    color: 'var(--sb-soil)',
    border: '1px solid var(--border-1)'
  }
};
function Badge({
  children,
  tone = 'plant'
}) {
  return /*#__PURE__*/React.createElement("span", {
    style: {
      ...badgeTones[tone],
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: 999,
      padding: '6px 12px',
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 10,
      letterSpacing: 'var(--tracking-caps)',
      textTransform: 'uppercase',
      lineHeight: 1
    }
  }, children);
}
Object.assign(__ds_scope, { Badge });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/Badge.jsx", error: String((e && e.message) || e) }); }

// components/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const base = {
  fontFamily: 'var(--font-body)',
  fontWeight: 700,
  fontSize: 12,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  padding: '14px 22px',
  borderRadius: 2,
  border: '1px solid transparent',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 10,
  textDecoration: 'none',
  transition: 'background var(--dur-2) var(--ease-out), color var(--dur-2) var(--ease-out)'
};
const buttonVariants = {
  primary: {
    background: 'var(--sb-soil)',
    color: 'var(--sb-ivory)'
  },
  plant: {
    background: 'var(--sb-plant)',
    color: 'var(--sb-ivory)'
  },
  ghost: {
    background: 'transparent',
    color: 'var(--sb-soil)',
    borderColor: 'var(--sb-soil)'
  },
  link: {
    background: 'transparent',
    color: 'var(--sb-soil)',
    padding: '6px 0',
    borderRadius: 0,
    borderBottom: '1px solid var(--sb-soil)'
  }
};
const buttonHover = {
  primary: {
    background: 'var(--sb-plant)'
  },
  plant: {
    background: 'var(--sb-plant-dark)'
  },
  ghost: {
    background: 'var(--sb-soil)',
    color: 'var(--sb-ivory)'
  },
  link: {
    color: 'var(--sb-plant)',
    borderBottomColor: 'var(--sb-plant)'
  }
};
function Button({
  children,
  variant = 'primary',
  arrow = false,
  href,
  onClick,
  ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const style = {
    ...base,
    ...buttonVariants[variant],
    ...(hover ? buttonHover[variant] : {})
  };
  const inner = [children, arrow ? /*#__PURE__*/React.createElement("svg", {
    key: "a",
    width: "10",
    height: "10",
    viewBox: "0 0 12 12",
    style: {
      transform: 'translateY(-1px)'
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10 L10 2 M5 2 H10 V7",
    stroke: "currentColor",
    strokeWidth: "1.5",
    fill: "none",
    strokeLinecap: "square"
  })) : null];
  const props = {
    style,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    onClick,
    ...rest
  };
  return href ? /*#__PURE__*/React.createElement("a", _extends({
    href: href
  }, props), inner) : /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, props), inner);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/Button.jsx", error: String((e && e.message) || e) }); }

// components/Card.jsx
try { (() => {
const cardFills = {
  plant: 'var(--sb-plant)',
  water: 'var(--sb-water)',
  sand: 'var(--sb-sand)'
};
function Card({
  kicker,
  title,
  meta,
  image,
  thumbFill = 'plant',
  href
}) {
  const [hover, setHover] = React.useState(false);
  return /*#__PURE__*/React.createElement("a", {
    href: href || '#',
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 4,
      overflow: 'hidden',
      border: '1px solid var(--border-1)',
      background: 'var(--bg-1)',
      textDecoration: 'none',
      transition: 'transform var(--dur-3) var(--ease-out)',
      transform: hover ? 'translateY(-3px)' : 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      aspectRatio: '4 / 3',
      background: cardFills[thumbFill],
      overflow: 'hidden'
    }
  }, image ? /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform var(--dur-4) var(--ease-out)',
      transform: hover ? 'scale(1.03)' : 'none'
    }
  }) : null), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '14px 16px',
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    }
  }, kicker ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 10,
      letterSpacing: 'var(--tracking-caps)',
      textTransform: 'uppercase',
      color: 'var(--sb-plant)'
    }
  }, kicker) : null, title ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 400,
      fontSize: 22,
      lineHeight: 1.05,
      color: 'var(--fg-1)'
    }
  }, title) : null, meta ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-body)',
      fontSize: 12,
      color: 'var(--fg-3)'
    }
  }, meta) : null));
}
Object.assign(__ds_scope, { Card });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/Card.jsx", error: String((e && e.message) || e) }); }

// components/SectionHeading.jsx
try { (() => {
function SectionHeading({
  eyebrow,
  title,
  body,
  align = 'left',
  onDark = false
}) {
  const fg = onDark ? 'var(--sb-ivory)' : 'var(--fg-1)';
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      textAlign: align,
      alignItems: align === 'center' ? 'center' : 'flex-start',
      maxWidth: 760
    }
  }, eyebrow ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 12,
      letterSpacing: 'var(--tracking-caps)',
      textTransform: 'uppercase',
      color: onDark ? 'var(--sb-sand)' : 'var(--sb-plant)'
    }
  }, eyebrow) : null, title ? /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 300,
      fontSize: 'var(--fs-h2)',
      lineHeight: 'var(--lh-tight)',
      letterSpacing: 'var(--tracking-display)',
      color: fg,
      textWrap: 'balance'
    }
  }, title) : null, body ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-body)',
      fontSize: 'var(--fs-body-lg)',
      lineHeight: 'var(--lh-body)',
      color: onDark ? 'rgba(255,253,248,0.78)' : 'var(--fg-2)',
      textWrap: 'pretty'
    }
  }, body) : null);
}
Object.assign(__ds_scope, { SectionHeading });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/SectionHeading.jsx", error: String((e && e.message) || e) }); }

// slides/deck-stage.js
try { (() => {
/**
 * <deck-stage> — reusable web component for HTML decks.
 *
 * Handles:
 *  (a) speaker notes — reads <script type="application/json" id="speaker-notes">
 *      and posts {slideIndexChanged: N} to the parent window on nav.
 *  (b) keyboard navigation — ←/→, PgUp/PgDn, Space, Home/End, number keys.
 *  (c) press R to reset to slide 0 (with a tasteful keyboard hint).
 *  (d) bottom-center overlay showing slide count + hints, fades out on idle.
 *  (e) auto-scaling — inner canvas is a fixed design size (default 1920×1080)
 *      scaled with `transform: scale()` to fit the viewport, letterboxed.
 *      Set the `noscale` attribute to render at authored size (1:1) — the
 *      PPTX exporter sets this so its DOM capture sees unscaled geometry.
 *  (f) print — `@media print` lays every slide out as its own page at the
 *      design size, so the browser's Print → Save as PDF produces a clean
 *      one-page-per-slide PDF with no extra setup.
 *  (g) thumbnail rail — resizable left-hand column of per-slide thumbnails
 *      (static clones). Click to navigate; ↑/↓ with a thumbnail focused to
 *      step between slides; drag to reorder; right-click for
 *      Skip / Move up / Move down / Delete (opens a Cancel/Delete confirm
 *      dialog). Drag the rail's right edge to resize; width persists to
 *      localStorage. Skipped slides carry `data-deck-skip`, are dimmed in
 *      the rail, omitted from prev/next navigation, and hidden at print.
 *      The rail is suppressed in presenting mode, on `noscale`, and via
 *      the `no-rail` attribute. Rail mutations dispatch a `deckchange`
 *      CustomEvent on the element: detail = {action, from, to, slide}.
 *
 * Slides are HIDDEN, not unmounted. Non-active slides stay in the DOM with
 * `visibility: hidden` + `opacity: 0`, so their state (videos, iframes,
 * form inputs, React trees) is preserved across navigation.
 *
 * Lifecycle event — the component dispatches a `slidechange` CustomEvent on
 * itself whenever the active slide changes (including the initial mount).
 * The event bubbles and composes out of shadow DOM, so you can listen on
 * the <deck-stage> element or on document:
 *
 *   document.querySelector('deck-stage').addEventListener('slidechange', (e) => {
 *     e.detail.index         // new 0-based index
 *     e.detail.previousIndex // previous index, or -1 on init
 *     e.detail.total         // total slide count
 *     e.detail.slide         // the new active slide element
 *     e.detail.previousSlide // the prior slide element, or null on init
 *     e.detail.reason        // 'init' | 'keyboard' | 'click' | 'tap' | 'api'
 *   });
 *
 * Persistence: none at the deck level. The host app keeps the current slide
 * in its own URL (?slide=) and re-delivers it via location.hash on load, so a
 * bare load with no hash always starts at slide 1.
 *
 * Usage:
 *   <style>deck-stage:not(:defined){visibility:hidden}</style>
 *   <deck-stage width="1920" height="1080">
 *     <section data-label="Title">...</section>
 *     <section data-label="Agenda">...</section>
 *   </deck-stage>
 *   <script src="deck-stage.js"></script>
 *
 * The :not(:defined) rule prevents a flash of the first slide at its
 * authored styles before this script runs and attaches the shadow root.
 *
 * Slides are the direct element children of <deck-stage>. Each slide is
 * automatically tagged with:
 *   - data-screen-label="NN Label"   (1-indexed, for comment flow)
 *   - data-om-validate="no_overflowing_text,no_overlapping_text,slide_sized_text"
 */

(() => {
  const DESIGN_W_DEFAULT = 1920;
  const DESIGN_H_DEFAULT = 1080;
  const OVERLAY_HIDE_MS = 1800;
  const VALIDATE_ATTR = 'no_overflowing_text,no_overlapping_text,slide_sized_text';
  const pad2 = n => String(n).padStart(2, '0');
  const stylesheet = `
    :host {
      position: fixed;
      inset: 0;
      display: block;
      background: #000;
      color: #fff;
      font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif;
      overflow: hidden;
    }
    /* connectedCallback holds this until document.fonts.ready (capped 2s) so
     * the first visible paint has the deck's real typography + final rail
     * layout. opacity (not visibility) so the active slide can't un-hide
     * itself via the ::slotted([data-deck-active]) visibility:visible rule.
     * Only the stage/rail hide — the black :host background stays, so the
     * iframe doesn't flash the page's default white. */
    :host([data-fonts-pending]) .stage,
    :host([data-fonts-pending]) .rail { opacity: 0; pointer-events: none; }

    .stage {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .canvas {
      position: relative;
      transform-origin: center center;
      flex-shrink: 0;
      background: #fff;
      will-change: transform;
    }

    /* Slides live in light DOM (via <slot>) so authored CSS still applies.
       We absolutely position each slotted child to stack them. */
    ::slotted(*) {
      position: absolute !important;
      inset: 0 !important;
      width: 100% !important;
      height: 100% !important;
      box-sizing: border-box !important;
      overflow: hidden;
      opacity: 0;
      pointer-events: none;
      visibility: hidden;
    }
    ::slotted([data-deck-active]) {
      opacity: 1;
      pointer-events: auto;
      visibility: visible;
    }

    /* Tap zones for mobile — back/forward thirds like Stories.
       Transparent, no visible UI, don't block the overlay. */
    .tapzones {
      position: fixed;
      inset: 0;
      display: flex;
      z-index: 2147482000;
      pointer-events: none;
    }
    .tapzone {
      flex: 1;
      pointer-events: auto;
      -webkit-tap-highlight-color: transparent;
    }
    /* Only activate tap zones on coarse pointers (touch devices). */
    @media (hover: hover) and (pointer: fine) {
      .tapzones { display: none; }
    }

    .overlay {
      position: fixed;
      left: 50%;
      bottom: 22px;
      transform: translate(-50%, 6px) scale(0.92);
      filter: blur(6px);
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 4px;
      background: #000;
      color: #fff;
      border-radius: 999px;
      font-size: 12px;
      font-feature-settings: "tnum" 1;
      letter-spacing: 0.01em;
      opacity: 0;
      pointer-events: none;
      transition: opacity 260ms ease, transform 260ms cubic-bezier(.2,.8,.2,1), filter 260ms ease;
      transform-origin: center bottom;
      z-index: 2147483000;
      user-select: none;
    }
    .overlay[data-visible] {
      opacity: 1;
      pointer-events: auto;
      transform: translate(-50%, 0) scale(1);
      filter: blur(0);
    }

    .btn {
      appearance: none;
      -webkit-appearance: none;
      background: transparent;
      border: 0;
      margin: 0;
      padding: 0;
      color: inherit;
      font: inherit;
      cursor: default;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 28px;
      min-width: 28px;
      border-radius: 999px;
      color: rgba(255,255,255,0.72);
      transition: background 140ms ease, color 140ms ease;
      -webkit-tap-highlight-color: transparent;
    }
    .btn:hover { background: rgba(255,255,255,0.12); color: #fff; }
    .btn:active { background: rgba(255,255,255,0.18); }
    .btn:focus { outline: none; }
    .btn:focus-visible { outline: none; }
    .btn::-moz-focus-inner { border: 0; }
    .btn svg { width: 14px; height: 14px; display: block; }
    .btn.reset {
      font-size: 11px;
      font-weight: 500;
      letter-spacing: 0.02em;
      padding: 0 10px 0 12px;
      gap: 6px;
      color: rgba(255,255,255,0.72);
    }
    .btn.reset .kbd {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 16px;
      height: 16px;
      padding: 0 4px;
      font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
      font-size: 10px;
      line-height: 1;
      color: rgba(255,255,255,0.88);
      background: rgba(255,255,255,0.12);
      border-radius: 4px;
    }

    .count {
      font-variant-numeric: tabular-nums;
      color: #fff;
      font-weight: 500;
      padding: 0 8px;
      min-width: 42px;
      text-align: center;
      font-size: 12px;
    }
    .count .sep { color: rgba(255,255,255,0.45); margin: 0 3px; font-weight: 400; }
    .count .total { color: rgba(255,255,255,0.55); }

    .divider {
      width: 1px;
      height: 14px;
      background: rgba(255,255,255,0.18);
      margin: 0 2px;
    }

    /* ── Thumbnail rail ──────────────────────────────────────────────────
       Fixed column on the left; each thumbnail is a static deep-clone of
       the light-DOM slide scaled into a 16:9 (or design-aspect) frame. The
       stage re-fits around it (see _fit); hidden during present / noscale
       / print so capture geometry and fullscreen output are unchanged. */
    .rail {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      width: var(--deck-rail-w, 188px);
      background: #141414;
      border-right: 1px solid rgba(255,255,255,0.08);
      overflow-y: auto;
      overflow-x: hidden;
      padding: 12px 10px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 12px;
      z-index: 2147482500;
      scrollbar-width: thin;
      scrollbar-color: rgba(255,255,255,0.18) transparent;
    }
    .rail::-webkit-scrollbar { width: 8px; }
    .rail::-webkit-scrollbar-track { background: transparent; margin: 2px; }
    .rail::-webkit-scrollbar-thumb {
      background: rgba(255,255,255,0.18);
      border-radius: 4px;
      border: 2px solid transparent;
      background-clip: content-box;
    }
    .rail::-webkit-scrollbar-thumb:hover {
      background: rgba(255,255,255,0.28);
      border: 2px solid transparent;
      background-clip: content-box;
    }
    :host([no-rail]) .rail,
    :host([noscale]) .rail { display: none; }
    .rail[data-presenting] { display: none; }
    /* User-driven show/hide (the TweaksPanel toggle) slides instead of
       popping. Transitions are gated on :host([data-rail-anim]) — set only
       for the 200ms around the toggle — so window-resize and rail-width
       drag (which also call _fit) don't lag behind the cursor. */
    .rail[data-user-hidden] { transform: translateX(-100%); }
    :host([data-rail-anim]) .rail { transition: transform 200ms cubic-bezier(.3,.7,.4,1); }
    :host([data-rail-anim]) .stage { transition: left 200ms cubic-bezier(.3,.7,.4,1); }
    :host([data-rail-anim]) .canvas { transition: transform 200ms cubic-bezier(.3,.7,.4,1); }
    /* transition shorthand replaces rather than merges — repeat the base
       .overlay opacity/transform/filter transitions so visibility changes
       during the 200ms toggle window still fade instead of popping. */
    :host([data-rail-anim]) .overlay {
      transition: margin-left 200ms cubic-bezier(.3,.7,.4,1),
                  opacity 260ms ease,
                  transform 260ms cubic-bezier(.2,.8,.2,1),
                  filter 260ms ease;
    }
    :host([data-rail-anim]) .tapzones { transition: left 200ms cubic-bezier(.3,.7,.4,1); }

    .thumb {
      position: relative;
      display: flex;
      align-items: flex-start;
      gap: 8px;
      cursor: pointer;
      user-select: none;
    }
    .thumb .num {
      width: 16px;
      flex-shrink: 0;
      font-size: 11px;
      font-weight: 500;
      text-align: right;
      color: rgba(255,255,255,0.55);
      padding-top: 2px;
      font-variant-numeric: tabular-nums;
    }
    .thumb .frame {
      position: relative;
      flex: 1;
      min-width: 0;
      aspect-ratio: var(--deck-aspect);
      background: #fff;
      border-radius: 4px;
      outline: 2px solid transparent;
      outline-offset: 0;
      overflow: hidden;
      transition: outline-color 120ms ease;
    }
    .thumb:hover .frame { outline-color: rgba(255,255,255,0.25); }
    .thumb { outline: none; }
    .thumb:focus-visible .frame { outline-color: rgba(255,255,255,0.5); }
    .thumb[data-current] .num { color: #fff; }
    .thumb[data-current] .frame { outline-color: #D97757; }
    .thumb[data-dragging] { opacity: 0.35; }
    .thumb::before {
      content: '';
      position: absolute;
      left: 24px;
      right: 0;
      height: 3px;
      border-radius: 2px;
      background: #D97757;
      opacity: 0;
      pointer-events: none;
    }
    .thumb[data-drop="before"]::before { top: -8px; opacity: 1; }
    .thumb[data-drop="after"]::before { bottom: -8px; opacity: 1; }
    .thumb[data-skip] .frame { opacity: 0.35; }
    .thumb[data-skip] .frame::after {
      content: 'Skipped';
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0,0,0,0.45);
      color: #fff;
      font-size: 10px;
      font-weight: 500;
      letter-spacing: 0.04em;
    }

    .ctxmenu {
      position: fixed;
      min-width: 150px;
      padding: 4px;
      background: #242424;
      border: 1px solid rgba(255,255,255,0.12);
      border-radius: 7px;
      box-shadow: 0 8px 24px rgba(0,0,0,0.45);
      z-index: 2147483100;
      display: none;
      font-size: 12px;
    }
    .ctxmenu[data-open] { display: block; }
    .ctxmenu button {
      display: block;
      width: 100%;
      appearance: none;
      border: 0;
      background: transparent;
      color: #e8e8e8;
      font: inherit;
      text-align: left;
      padding: 6px 10px;
      border-radius: 4px;
      cursor: pointer;
    }
    .ctxmenu button:hover:not(:disabled) { background: rgba(255,255,255,0.08); }
    .ctxmenu button:disabled { opacity: 0.35; cursor: default; }
    .ctxmenu hr {
      border: 0;
      border-top: 1px solid rgba(255,255,255,0.1);
      margin: 4px 2px;
    }

    .rail-resize {
      position: fixed;
      left: calc(var(--deck-rail-w, 188px) - 3px);
      top: 0;
      bottom: 0;
      width: 6px;
      cursor: col-resize;
      z-index: 2147482600;
      touch-action: none;
    }
    .rail-resize:hover,
    .rail-resize[data-dragging] { background: rgba(255,255,255,0.12); }
    :host([no-rail]) .rail-resize,
    :host([noscale]) .rail-resize,
    .rail[data-presenting] + .rail-resize,
    .rail[data-user-hidden] + .rail-resize { display: none; }

    /* Delete-confirm popup — matches the SPA's ConfirmDialog layout
       (title + message body, depressed footer with Cancel / Delete). */
    .confirm-backdrop {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.45);
      z-index: 2147483200;
      display: none;
      align-items: center;
      justify-content: center;
    }
    .confirm-backdrop[data-open] { display: flex; }
    .confirm {
      width: 320px;
      max-width: calc(100vw - 32px);
      background: #2a2a2a;
      color: #e8e8e8;
      border: 1px solid rgba(255,255,255,0.12);
      border-radius: 12px;
      box-shadow: 0 12px 32px rgba(0,0,0,0.5);
      overflow: hidden;
      font-family: inherit;
      animation: deck-confirm-in 0.18s ease;
    }
    @keyframes deck-confirm-in {
      from { opacity: 0; transform: scale(0.96); }
      to { opacity: 1; transform: scale(1); }
    }
    .confirm .body { padding: 20px 20px 16px; }
    .confirm .title { font-size: 14px; font-weight: 600; margin-bottom: 4px; }
    .confirm .msg { font-size: 13px; line-height: 1.5; color: rgba(255,255,255,0.65); }
    .confirm .footer {
      padding: 14px 20px;
      background: #1f1f1f;
      border-top: 1px solid rgba(255,255,255,0.08);
      display: flex;
      justify-content: flex-end;
      gap: 8px;
    }
    .confirm button {
      appearance: none;
      font: inherit;
      font-size: 13px;
      font-weight: 500;
      padding: 8px 16px;
      border-radius: 8px;
      cursor: pointer;
    }
    .confirm .cancel {
      background: transparent;
      border: 0;
      color: rgba(255,255,255,0.8);
    }
    .confirm .cancel:hover { background: rgba(255,255,255,0.08); }
    .confirm .danger {
      background: #c96442;
      border: 1px solid rgba(0,0,0,0.15);
      color: #fff;
      box-shadow: 0 1px 3px rgba(166,50,68,0.3), 0 2px 6px rgba(166,50,68,0.18);
    }
    .confirm .danger:hover { background: #b5563a; }

    /* ── Print: one page per slide, no chrome ────────────────────────────
       The screen layout stacks every slide at inset:0 inside a scaled
       canvas; for print we want them in document flow at the authored
       design size so the browser paginates one slide per sheet. The
       @page size is set from the width/height attributes via the inline
       <style id="deck-stage-print-page"> that connectedCallback injects
       into <head> (the @page at-rule has no effect inside shadow DOM). */
    @media print {
      :host {
        position: static;
        inset: auto;
        background: none;
        overflow: visible;
        color: inherit;
      }
      .stage { position: static; display: block; }
      .canvas {
        transform: none !important;
        width: auto !important;
        height: auto !important;
        background: none;
        will-change: auto;
      }
      ::slotted(*) {
        position: relative !important;
        inset: auto !important;
        width: var(--deck-design-w) !important;
        height: var(--deck-design-h) !important;
        box-sizing: border-box !important;
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto;
        break-after: page;
        page-break-after: always;
        break-inside: avoid;
        overflow: hidden;
      }
      /* :last-child alone isn't enough once data-deck-skip hides the
         trailing slide(s) — the last *visible* slide still carries
         break-after:page and prints a blank sheet. _markLastVisible()
         maintains data-deck-last-visible on the last non-skipped slide. */
      ::slotted(*:last-child),
      ::slotted([data-deck-last-visible]) {
        break-after: auto;
        page-break-after: auto;
      }
      ::slotted([data-deck-skip]) { display: none !important; }
      .overlay, .tapzones, .rail, .rail-resize, .ctxmenu, .confirm-backdrop { display: none !important; }
    }
  `;
  class DeckStage extends HTMLElement {
    static get observedAttributes() {
      return ['width', 'height', 'noscale', 'no-rail'];
    }
    constructor() {
      super();
      this._root = this.attachShadow({
        mode: 'open'
      });
      this._index = 0;
      this._slides = [];
      this._notes = [];
      this._hideTimer = null;
      this._mouseIdleTimer = null;
      this._menuIndex = -1;
      this._onKey = this._onKey.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onSlotChange = this._onSlotChange.bind(this);
      this._onMouseMove = this._onMouseMove.bind(this);
      this._onTapBack = this._onTapBack.bind(this);
      this._onTapForward = this._onTapForward.bind(this);
      this._onMessage = this._onMessage.bind(this);
      // Capture-phase close so a click anywhere dismisses the menu, but
      // ignore clicks that land inside the menu itself — otherwise the
      // capture handler runs before the menu's own (bubble) handler and
      // clears _menuIndex out from under it.
      this._onDocClick = e => {
        if (this._menu && e.composedPath && e.composedPath().includes(this._menu)) return;
        this._closeMenu();
      };
    }
    get designWidth() {
      return parseInt(this.getAttribute('width'), 10) || DESIGN_W_DEFAULT;
    }
    get designHeight() {
      return parseInt(this.getAttribute('height'), 10) || DESIGN_H_DEFAULT;
    }
    connectedCallback() {
      // Presenter-view popup loads deckUrl?_snthumb=...#N for its prev/cur/
      // next thumbnails — the rail has no business rendering inside those
      // (wrong scale, and it offsets the stage so the thumb shows a gutter).
      if (/[?&]_snthumb=/.test(location.search)) this.setAttribute('no-rail', '');
      this._render();
      this._loadNotes();
      this._syncPrintPageRule();
      window.addEventListener('keydown', this._onKey);
      window.addEventListener('resize', this._onResize);
      window.addEventListener('mousemove', this._onMouseMove, {
        passive: true
      });
      window.addEventListener('message', this._onMessage);
      window.addEventListener('click', this._onDocClick, true);
      // Initial collection + layout happens via slotchange, which fires on mount.
      this._enableRail();
      // Hold the stage hidden until webfonts are ready so the first visible
      // paint has the deck's real typography — the :not(:defined) guard in
      // the page HTML only covers custom-element upgrade, not font load.
      // Capped so a 404'd font URL can't blank the deck indefinitely.
      this.setAttribute('data-fonts-pending', '');
      const reveal = () => this.removeAttribute('data-fonts-pending');
      // rAF first: fonts.ready is a pre-resolved promise until layout has
      // resolved the slotted text's font-family and pushed a FontFace into
      // 'loading'. Reading it here in connectedCallback (parse-time) would
      // settle the race in a microtask before any font fetch starts.
      requestAnimationFrame(() => {
        Promise.race([document.fonts ? document.fonts.ready : Promise.resolve(), new Promise(r => setTimeout(r, 2000))]).then(reveal, reveal);
      });
    }
    _enableRail() {
      // Idempotent — older host builds still post __omelette_rail_enabled.
      // no-rail guard keeps the observers/stylesheet walk off the cheap path
      // for presenter-popup thumbnail iframes (up to 9 per view).
      if (this._railEnabled || this.hasAttribute('no-rail')) return;
      this._railEnabled = true;
      // Per-viewer preference — restored alongside rail width. Default on;
      // only a stored '0' (from the TweaksPanel toggle) hides it.
      this._railVisible = true;
      try {
        if (localStorage.getItem('deck-stage.railVisible') === '0') this._railVisible = false;
      } catch (e) {}
      // Live thumbnail updates: watch the light-DOM slides for content
      // edits and re-clone just the affected thumb(s), debounced. Ignore
      // the data-deck-* / data-screen-label / data-om-validate attributes
      // this component itself writes so nav and skip don't trigger
      // spurious refreshes.
      const OWN_ATTRS = /^data-(deck-|screen-label$|om-validate$)/;
      this._liveDirty = new Set();
      this._liveObserver = new MutationObserver(records => {
        for (const r of records) {
          if (r.type === 'attributes' && OWN_ATTRS.test(r.attributeName || '')) continue;
          let n = r.target;
          while (n && n.parentElement !== this) n = n.parentElement;
          if (n && this._slideSet && this._slideSet.has(n)) this._liveDirty.add(n);
        }
        if (this._liveDirty.size && !this._liveTimer) {
          this._liveTimer = setTimeout(() => {
            this._liveTimer = null;
            this._liveDirty.forEach(s => this._refreshThumb(s));
            this._liveDirty.clear();
          }, 200);
        }
      });
      this._liveObserver.observe(this, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true
      });
      // Lazy thumbnail materialization — clone the slide only when its
      // frame scrolls into (or near) the rail viewport. rootMargin gives
      // ~4 thumbs of pre-load so fast scrolling doesn't flash blanks.
      this._railObserver = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting && e.target.__deckThumb) {
            this._materialize(e.target.__deckThumb);
          }
        });
      }, {
        root: this._rail,
        rootMargin: '400px 0px'
      });
      // Tweaks typically change CSS vars / attrs OUTSIDE <deck-stage>
      // (on <html>, <body>, a wrapper div, or a <style> tag), which
      // _liveObserver can't see. Re-snapshot author CSS (constructable
      // sheet is shared by reference, so one replaceSync updates every
      // thumb shadow root) and re-sync each thumb host's attrs + custom
      // properties. In-slide DOM mutations are _liveObserver's job.
      // Debounced so slider drags don't thrash.
      this._onTweakChange = () => {
        clearTimeout(this._tweakTimer);
        this._tweakTimer = setTimeout(() => {
          this._snapshotAuthorCss();
          // One getComputedStyle for the whole batch — each
          // getPropertyValue read below reuses the same computed style
          // as long as nothing invalidates layout between thumbs.
          const cs = getComputedStyle(this);
          (this._thumbs || []).forEach(t => {
            if (t.host) this._syncThumbHostAttrs(t.host, cs);
          });
        }, 120);
      };
      window.addEventListener('tweakchange', this._onTweakChange);
      this._snapshotAuthorCss();
      // Build the rail now that it's enabled — slotchange already fired,
      // so _renderRail's early-return skipped the initial build.
      this._syncRailHidden();
      this._renderRail();
      this._fit();
    }

    /** Snapshot document stylesheets into a constructable sheet that each
     *  thumbnail's nested shadow root adopts — so author CSS styles the
     *  cloned slide content without touching this component's chrome.
     *  Cross-origin sheets throw on .cssRules — skip them. Re-callable:
     *  the existing constructable sheet is reused via replaceSync so every
     *  already-adopted shadow root picks up the fresh CSS without re-adopt. */
    _snapshotAuthorCss() {
      // :root in an adopted sheet inside a shadow root matches nothing
      // (only the document root qualifies), so author rules like
      // `:root[data-voice="modern"] .serif` never reach the clones.
      // Rewrite :root → :host and mirror <html>'s data-*/class/lang onto
      // each thumb host (see _syncThumbHostAttrs) so the same selectors
      // match inside the thumbnail's shadow tree.
      const authorCss = Array.from(document.styleSheets).map(sh => {
        try {
          return Array.from(sh.cssRules).map(r => r.cssText).join('\n');
        } catch (e) {
          return '';
        }
      }).join('\n')
      // The shadow host is featureless outside the functional :host(...)
      // form, so any compound on :root — [attr], .class, #id, :pseudo —
      // must become :host(<compound>) not :host<compound>. Same for the
      // html type selector (Tailwind class-strategy dark mode emits
      // html.dark; Pico uses html[data-theme]), which has nothing to
      // match inside the thumb's shadow tree.
      .replace(/:root((?:\[[^\]]*\]|[.#][-\w]+|:[-\w]+(?:\([^)]*\))?)+)/g, ':host($1)').replace(/:root\b/g, ':host').replace(/(^|[\s,>~+(}])html((?:\[[^\]]*\]|[.#][-\w]+|:[-\w]+(?:\([^)]*\))?)+)(?![-\w])/g, '$1:host($2)').replace(/(^|[\s,>~+(}])html(?![-\w])/g, '$1:host');
      // Every custom property the author references. _syncThumbHostAttrs
      // mirrors each one's *computed* value at <deck-stage> onto the
      // thumb host so the live value wins over the :host default above
      // regardless of which ancestor the tweak wrote to (<html>, <body>,
      // a wrapper div, or the deck-stage element itself all inherit
      // down to getComputedStyle(this)).
      this._authorVars = new Set(authorCss.match(/--[\w-]+/g) || []);
      try {
        if (!this._adoptedSheet) this._adoptedSheet = new CSSStyleSheet();
        this._adoptedSheet.replaceSync(authorCss);
      } catch (e) {
        this._adoptedSheet = null;
        this._authorCss = authorCss;
      }
    }
    _syncThumbHostAttrs(host, cs) {
      const de = document.documentElement;
      // setAttribute overwrites but can't delete — an attr removed from
      // <html> (toggleAttribute off, classList emptied) would linger on
      // the host and :host([data-*]) / :host(.foo) rules would keep
      // matching. Remove stale mirrored attrs first; iterate backward
      // because removeAttribute mutates the live NamedNodeMap.
      for (let i = host.attributes.length - 1; i >= 0; i--) {
        const n = host.attributes[i].name;
        if ((n.startsWith('data-') || n === 'class' || n === 'lang') && !de.hasAttribute(n)) {
          host.removeAttribute(n);
        }
      }
      for (const a of de.attributes) {
        if (a.name.startsWith('data-') || a.name === 'class' || a.name === 'lang') {
          host.setAttribute(a.name, a.value);
        }
      }
      // The :root→:host rewrite in _snapshotAuthorCss pins each custom
      // property to its stylesheet default on the thumb host, shadowing
      // the live value that would otherwise inherit. Tweaks can write the
      // live value on any ancestor — <html>, <body>, a wrapper div, the
      // deck-stage element — so read it as the *computed* value at
      // <deck-stage> (which sees the whole inheritance chain) rather than
      // trying to guess which element the author wrote to. Inline on the
      // host beats the :host{} rule. remove-stale covers vars dropped
      // from the stylesheet between snapshots.
      const vars = this._authorVars || new Set();
      for (let i = host.style.length - 1; i >= 0; i--) {
        const p = host.style[i];
        if (p.startsWith('--') && !vars.has(p)) host.style.removeProperty(p);
      }
      const live = cs || getComputedStyle(this);
      vars.forEach(p => {
        const v = live.getPropertyValue(p);
        if (v) host.style.setProperty(p, v.trim());else host.style.removeProperty(p);
      });
    }
    disconnectedCallback() {
      window.removeEventListener('keydown', this._onKey);
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('mousemove', this._onMouseMove);
      window.removeEventListener('message', this._onMessage);
      window.removeEventListener('click', this._onDocClick, true);
      if (this._hideTimer) clearTimeout(this._hideTimer);
      if (this._mouseIdleTimer) clearTimeout(this._mouseIdleTimer);
      if (this._liveTimer) clearTimeout(this._liveTimer);
      if (this._tweakTimer) clearTimeout(this._tweakTimer);
      if (this._railAnimTimer) clearTimeout(this._railAnimTimer);
      if (this._scaleRaf) cancelAnimationFrame(this._scaleRaf);
      if (this._liveObserver) this._liveObserver.disconnect();
      if (this._railObserver) this._railObserver.disconnect();
      if (this._onTweakChange) window.removeEventListener('tweakchange', this._onTweakChange);
    }
    attributeChangedCallback() {
      if (this._canvas) {
        this._canvas.style.width = this.designWidth + 'px';
        this._canvas.style.height = this.designHeight + 'px';
        this._canvas.style.setProperty('--deck-design-w', this.designWidth + 'px');
        this._canvas.style.setProperty('--deck-design-h', this.designHeight + 'px');
        if (this._rail) {
          this._rail.style.setProperty('--deck-aspect', this.designWidth + '/' + this.designHeight);
        }
        this._fit();
        this._scaleThumbs();
        this._syncPrintPageRule();
      }
    }
    _render() {
      const style = document.createElement('style');
      style.textContent = stylesheet;
      const stage = document.createElement('div');
      stage.className = 'stage';
      const canvas = document.createElement('div');
      canvas.className = 'canvas';
      canvas.style.width = this.designWidth + 'px';
      canvas.style.height = this.designHeight + 'px';
      canvas.style.setProperty('--deck-design-w', this.designWidth + 'px');
      canvas.style.setProperty('--deck-design-h', this.designHeight + 'px');
      const slot = document.createElement('slot');
      slot.addEventListener('slotchange', this._onSlotChange);
      canvas.appendChild(slot);
      stage.appendChild(canvas);

      // Tap zones (mobile): left third = back, right third = forward.
      const tapzones = document.createElement('div');
      tapzones.className = 'tapzones export-hidden';
      tapzones.setAttribute('aria-hidden', 'true');
      tapzones.setAttribute('data-noncommentable', '');
      const tzBack = document.createElement('div');
      tzBack.className = 'tapzone tapzone--back';
      const tzMid = document.createElement('div');
      tzMid.className = 'tapzone tapzone--mid';
      tzMid.style.pointerEvents = 'none';
      const tzFwd = document.createElement('div');
      tzFwd.className = 'tapzone tapzone--fwd';
      tzBack.addEventListener('click', this._onTapBack);
      tzFwd.addEventListener('click', this._onTapForward);
      tapzones.append(tzBack, tzMid, tzFwd);

      // Overlay: compact, solid black, with clickable controls.
      const overlay = document.createElement('div');
      overlay.className = 'overlay export-hidden';
      overlay.setAttribute('role', 'toolbar');
      overlay.setAttribute('aria-label', 'Deck controls');
      overlay.setAttribute('data-noncommentable', '');
      overlay.innerHTML = `
        <button class="btn prev" type="button" aria-label="Previous slide" title="Previous (←)">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3L5 8l5 5"/></svg>
        </button>
        <span class="count" aria-live="polite"><span class="current">1</span><span class="sep">/</span><span class="total">1</span></span>
        <button class="btn next" type="button" aria-label="Next slide" title="Next (→)">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg>
        </button>
        <span class="divider"></span>
        <button class="btn reset" type="button" aria-label="Reset to first slide" title="Reset (R)">Reset<span class="kbd">R</span></button>
      `;
      overlay.querySelector('.prev').addEventListener('click', () => this._advance(-1, 'click'));
      overlay.querySelector('.next').addEventListener('click', () => this._advance(1, 'click'));
      overlay.querySelector('.reset').addEventListener('click', () => this._go(0, 'click'));

      // Thumbnail rail + context menu. Thumbnails are populated in
      // _renderRail() after _collectSlides().
      const rail = document.createElement('div');
      rail.className = 'rail export-hidden';
      rail.setAttribute('data-noncommentable', '');
      rail.style.setProperty('--deck-aspect', this.designWidth + '/' + this.designHeight);
      // Edge auto-scroll while dragging a thumb near the rail's top/bottom
      // so off-screen drop targets are reachable. Native dragover fires
      // continuously while the pointer is stationary, so a per-event nudge
      // (ramped by edge proximity) is enough — no rAF loop needed.
      rail.addEventListener('dragover', e => {
        if (this._dragFrom == null) return;
        const r = rail.getBoundingClientRect();
        const EDGE = 40;
        const dt = e.clientY - r.top;
        const db = r.bottom - e.clientY;
        if (dt < EDGE) rail.scrollTop -= Math.ceil((EDGE - dt) / 3);else if (db < EDGE) rail.scrollTop += Math.ceil((EDGE - db) / 3);
      });
      const menu = document.createElement('div');
      menu.className = 'ctxmenu export-hidden';
      menu.setAttribute('data-noncommentable', '');
      menu.innerHTML = `
        <button type="button" data-act="skip">Skip slide</button>
        <button type="button" data-act="up">Move up</button>
        <button type="button" data-act="down">Move down</button>
        <hr>
        <button type="button" data-act="delete">Delete slide</button>
      `;
      menu.addEventListener('click', e => {
        const act = e.target && e.target.getAttribute && e.target.getAttribute('data-act');
        if (!act) return;
        const i = this._menuIndex;
        this._closeMenu();
        if (act === 'skip') this._toggleSkip(i);else if (act === 'up') this._moveSlide(i, i - 1);else if (act === 'down') this._moveSlide(i, i + 1);else if (act === 'delete') this._openConfirm(i);
      });
      menu.addEventListener('contextmenu', e => e.preventDefault());

      // Rail resize handle — drag to set --deck-rail-w, persisted to
      // localStorage so the width survives reloads.
      const resize = document.createElement('div');
      resize.className = 'rail-resize export-hidden';
      resize.setAttribute('data-noncommentable', '');
      resize.addEventListener('pointerdown', e => {
        e.preventDefault();
        resize.setPointerCapture(e.pointerId);
        resize.setAttribute('data-dragging', '');
        const move = ev => this._setRailWidth(ev.clientX);
        const up = () => {
          resize.removeEventListener('pointermove', move);
          resize.removeEventListener('pointerup', up);
          resize.removeEventListener('pointercancel', up);
          resize.removeAttribute('data-dragging');
          try {
            localStorage.setItem('deck-stage.railWidth', String(this._railPx));
          } catch (err) {}
        };
        resize.addEventListener('pointermove', move);
        resize.addEventListener('pointerup', up);
        resize.addEventListener('pointercancel', up);
      });

      // Delete-confirm dialog — mirrors the SPA's ConfirmDialog layout.
      const confirm = document.createElement('div');
      confirm.className = 'confirm-backdrop export-hidden';
      confirm.setAttribute('data-noncommentable', '');
      confirm.innerHTML = `
        <div class="confirm" role="dialog" aria-modal="true">
          <div class="body">
            <div class="title">Delete slide?</div>
            <div class="msg">This slide will be removed from the deck.</div>
          </div>
          <div class="footer">
            <button type="button" class="cancel">Cancel</button>
            <button type="button" class="danger">Delete</button>
          </div>
        </div>
      `;
      confirm.addEventListener('click', e => {
        if (e.target === confirm) this._closeConfirm();
      });
      confirm.querySelector('.cancel').addEventListener('click', () => this._closeConfirm());
      confirm.querySelector('.danger').addEventListener('click', () => {
        const i = this._confirmIndex;
        this._closeConfirm();
        this._deleteSlide(i);
      });
      this._root.append(style, rail, resize, stage, tapzones, overlay, menu, confirm);
      this._canvas = canvas;
      this._slot = slot;
      this._overlay = overlay;
      this._tapzones = tapzones;
      this._rail = rail;
      this._resize = resize;
      this._menu = menu;
      this._confirm = confirm;
      this._countEl = overlay.querySelector('.current');
      this._totalEl = overlay.querySelector('.total');

      // Restore persisted rail width.
      let rw = 188;
      try {
        const s = localStorage.getItem('deck-stage.railWidth');
        if (s) rw = parseInt(s, 10) || rw;
      } catch (err) {}
      this._setRailWidth(rw);
      this._syncRailHidden();
    }
    _setRailWidth(px) {
      const w = Math.max(120, Math.min(360, Math.round(px)));
      this._railPx = w;
      this.style.setProperty('--deck-rail-w', w + 'px');
      this._fit();
      // _scaleThumbs forces a sync layout (frame.offsetWidth) then writes
      // N transforms. During a resize drag this runs per-pointermove;
      // coalesce to one per frame.
      if (!this._scaleRaf) {
        this._scaleRaf = requestAnimationFrame(() => {
          this._scaleRaf = null;
          this._scaleThumbs();
        });
      }
    }

    /** @page must live in the document stylesheet — it's a no-op inside
     *  shadow DOM. Inject/update a single <head> style tag so the print
     *  sheet matches the design size and Save-as-PDF yields one slide per
     *  page with no margins. */
    _syncPrintPageRule() {
      const id = 'deck-stage-print-page';
      let tag = document.getElementById(id);
      if (!tag) {
        tag = document.createElement('style');
        tag.id = id;
        document.head.appendChild(tag);
      }
      tag.textContent = '@page { size: ' + this.designWidth + 'px ' + this.designHeight + 'px; margin: 0; } ' + '@media print { html, body { margin: 0 !important; padding: 0 !important; background: none !important; overflow: visible !important; height: auto !important; } ' + '* { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }';
    }
    _onSlotChange() {
      // Rail mutations (delete/move) already reconcile synchronously and
      // emit slidechange with reason 'api'; skip the async slotchange that
      // would otherwise re-broadcast with reason 'init'.
      if (this._squelchSlotChange) {
        this._squelchSlotChange = false;
        return;
      }
      this._collectSlides();
      this._restoreIndex();
      this._applyIndex({
        showOverlay: false,
        broadcast: true,
        reason: 'init'
      });
      this._fit();
    }
    _collectSlides() {
      const assigned = this._slot.assignedElements({
        flatten: true
      });
      this._slides = assigned.filter(el => {
        // Skip template/style/script nodes even if someone slots them.
        const tag = el.tagName;
        return tag !== 'TEMPLATE' && tag !== 'SCRIPT' && tag !== 'STYLE';
      });
      this._slideSet = new Set(this._slides);
      this._slides.forEach((slide, i) => {
        const n = i + 1;
        // Determine a label for comment flow: prefer explicit data-label,
        // then an existing data-screen-label, then first heading, else "Slide".
        let label = slide.getAttribute('data-label');
        if (!label) {
          const existing = slide.getAttribute('data-screen-label');
          if (existing) {
            // Strip any leading number the author may have included.
            label = existing.replace(/^\s*\d+\s*/, '').trim() || existing;
          }
        }
        if (!label) {
          const h = slide.querySelector('h1, h2, h3, [data-title]');
          if (h) label = (h.textContent || '').trim().slice(0, 40);
        }
        if (!label) label = 'Slide';
        slide.setAttribute('data-screen-label', `${pad2(n)} ${label}`);

        // Validation attribute for comment flow / auto-checks.
        if (!slide.hasAttribute('data-om-validate')) {
          slide.setAttribute('data-om-validate', VALIDATE_ATTR);
        }
        slide.setAttribute('data-deck-slide', String(i));
      });
      if (this._totalEl) this._totalEl.textContent = String(this._slides.length || 1);
      if (this._index >= this._slides.length) this._index = Math.max(0, this._slides.length - 1);
      this._markLastVisible();
      this._renderRail();
    }

    /** Tag the last non-skipped slide so print CSS can drop its
     *  break-after (see the @media print comment above — :last-child
     *  alone matches a hidden skipped slide). */
    _markLastVisible() {
      let last = null;
      this._slides.forEach(s => {
        s.removeAttribute('data-deck-last-visible');
        if (!s.hasAttribute('data-deck-skip')) last = s;
      });
      if (last) last.setAttribute('data-deck-last-visible', '');
    }
    _loadNotes() {
      const tag = document.getElementById('speaker-notes');
      if (!tag) {
        this._notes = [];
        return;
      }
      try {
        const parsed = JSON.parse(tag.textContent || '[]');
        if (Array.isArray(parsed)) this._notes = parsed;
      } catch (e) {
        console.warn('[deck-stage] Failed to parse #speaker-notes JSON:', e);
        this._notes = [];
      }
    }
    _restoreIndex() {
      // The host's ?slide= param is delivered as a #<int> hash (1-indexed) on
      // the iframe src. No hash → slide 1; the deck itself keeps no position
      // state across loads.
      const h = (location.hash || '').match(/^#(\d+)$/);
      if (h) {
        const n = parseInt(h[1], 10) - 1;
        if (n >= 0 && n < this._slides.length) this._index = n;
      }
    }
    _applyIndex({
      showOverlay = true,
      broadcast = true,
      reason = 'init'
    } = {}) {
      if (!this._slides.length) return;
      const prev = this._prevIndex == null ? -1 : this._prevIndex;
      const curr = this._index;
      // Keep the iframe's own hash in sync so an in-iframe location.reload()
      // (reload banner path in viewer-handle.ts) lands on the current slide,
      // not the stale deep-link hash from initial load.
      try {
        history.replaceState(null, '', '#' + (curr + 1));
      } catch (e) {}
      this._slides.forEach((s, i) => {
        if (i === curr) s.setAttribute('data-deck-active', '');else s.removeAttribute('data-deck-active');
      });
      if (this._countEl) this._countEl.textContent = String(curr + 1);
      // Follow-scroll on every navigation (init deep-link, keyboard, click,
      // tap, external goTo) — the only time we *don't* want the rail to
      // track current is after a rail-internal mutation, where _renderRail
      // has already restored the user's scroll position and yanking back to
      // current would undo it.
      this._syncRail(reason !== 'mutation');
      if (broadcast) {
        // (1) Legacy: host-window postMessage for speaker-notes renderers.
        try {
          window.postMessage({
            slideIndexChanged: curr,
            deckTotal: this._slides.length,
            deckSkipped: this._skippedIndices()
          }, '*');
        } catch (e) {}

        // (2) In-page CustomEvent on the <deck-stage> element itself.
        //     Bubbles and composes out of shadow DOM so slide code can listen:
        //       document.querySelector('deck-stage').addEventListener('slidechange', e => {
        //         e.detail.index, e.detail.previousIndex, e.detail.total, e.detail.slide, e.detail.reason
        //       });
        const detail = {
          index: curr,
          previousIndex: prev,
          total: this._slides.length,
          slide: this._slides[curr] || null,
          previousSlide: prev >= 0 ? this._slides[prev] || null : null,
          reason: reason // 'init' | 'keyboard' | 'click' | 'tap' | 'api'
        };
        this.dispatchEvent(new CustomEvent('slidechange', {
          detail,
          bubbles: true,
          composed: true
        }));
      }
      this._prevIndex = curr;
      if (showOverlay) this._flashOverlay();
    }
    _flashOverlay() {
      // Host posts __omelette_presenting while in fullscreen/tab presentation
      // mode — suppress the nav footer entirely (both hover and slide-change
      // flash) so the audience sees clean slides.
      if (!this._overlay || this._presenting) return;
      this._overlay.setAttribute('data-visible', '');
      if (this._hideTimer) clearTimeout(this._hideTimer);
      this._hideTimer = setTimeout(() => {
        this._overlay.removeAttribute('data-visible');
      }, OVERLAY_HIDE_MS);
    }
    _railWidth() {
      // State-based, no offsetWidth: the first _fit() can run before the
      // rail has had layout on some load paths, and a 0 there paints the
      // slide full-width for one frame before the post-slotchange _fit()
      // corrects it.
      if (!this._railEnabled || !this._railVisible || this.hasAttribute('no-rail') || this.hasAttribute('noscale') || this._presenting) return 0;
      return this._railPx || 0;
    }
    _fit() {
      if (!this._canvas) return;
      const stage = this._canvas.parentElement;
      // PPTX export sets noscale so the DOM capture sees authored-size
      // geometry — the scaled canvas is in shadow DOM, so the exporter's
      // resetTransformSelector can't reach .canvas.style.transform directly.
      if (this.hasAttribute('noscale')) {
        this._canvas.style.transform = 'none';
        if (stage) stage.style.left = '0';
        if (this._overlay) this._overlay.style.marginLeft = '0';
        if (this._tapzones) this._tapzones.style.left = '0';
        return;
      }
      const rw = this._railWidth();
      if (stage) stage.style.left = rw + 'px';
      // Overlay is centred on the viewport via left:50% + translate(-50%);
      // marginLeft shifts the centre by rw/2 so it lands in the middle of
      // the [rw, innerWidth] stage region. Tapzones just inset from rw.
      if (this._overlay) this._overlay.style.marginLeft = rw / 2 + 'px';
      if (this._tapzones) this._tapzones.style.left = rw + 'px';
      const vw = window.innerWidth - rw;
      const vh = window.innerHeight;
      const s = Math.min(vw / this.designWidth, vh / this.designHeight);
      this._canvas.style.transform = `scale(${s})`;
    }
    _onResize() {
      this._fit();
    }
    _onMouseMove() {
      // Keep overlay visible while mouse moves; hide after idle.
      this._flashOverlay();
    }
    _onMessage(e) {
      const d = e.data;
      if (d && typeof d.__omelette_presenting === 'boolean') {
        this._presenting = d.__omelette_presenting;
        if (this._presenting && this._overlay) {
          this._overlay.removeAttribute('data-visible');
          if (this._hideTimer) clearTimeout(this._hideTimer);
        }
        this._syncRailHidden();
        this._closeMenu();
        this._closeConfirm();
        this._fit();
        this._scaleThumbs();
      }
      // Per-viewer show/hide, driven by the TweaksPanel's auto-injected
      // "Thumbnail rail" toggle (or any author script). Independent of
      // whether the Tweaks panel itself is open — closing the panel
      // doesn't change rail visibility. Persists alongside rail width.
      if (d && d.type === '__deck_rail_visible' && typeof d.on === 'boolean') {
        if (d.on === this._railVisible) return;
        this._railVisible = d.on;
        try {
          localStorage.setItem('deck-stage.railVisible', d.on ? '1' : '0');
        } catch (e) {}
        // Arm the transition, commit it, then flip state — otherwise the
        // browser coalesces both writes and nothing animates on show.
        this.setAttribute('data-rail-anim', '');
        void (this._rail && this._rail.offsetHeight);
        this._syncRailHidden();
        this._fit();
        this._scaleThumbs();
        clearTimeout(this._railAnimTimer);
        this._railAnimTimer = setTimeout(() => this.removeAttribute('data-rail-anim'), 220);
      }
      if (d && d.type === '__omelette_rail_enabled') this._enableRail();
    }
    _syncRailHidden() {
      if (!this._rail) return;
      // data-presenting is the hard hide (display:none) for flag-off and
      // presentation mode — instant, no transition. data-user-hidden is
      // the soft hide (translateX(-100%)) for the viewer's rail toggle,
      // so show/hide slides under :host([data-rail-anim]).
      const hard = !this._railEnabled || this._presenting;
      if (hard) this._rail.setAttribute('data-presenting', '');else this._rail.removeAttribute('data-presenting');
      if (!this._railVisible) this._rail.setAttribute('data-user-hidden', '');else this._rail.removeAttribute('data-user-hidden');
      // translateX hide leaves thumbs (tabIndex=0) in the tab order —
      // inert keeps them unfocusable while the rail is off-screen.
      this._rail.inert = hard || !this._railVisible;
    }
    _onTapBack(e) {
      e.preventDefault();
      this._advance(-1, 'tap');
    }
    _onTapForward(e) {
      e.preventDefault();
      this._advance(1, 'tap');
    }
    _onKey(e) {
      // Ignore when the user is typing.
      const t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      // Confirm dialog swallows nav keys while open; Escape cancels. Enter
      // is left to the focused button's native activation so Tab→Cancel
      // →Enter activates Cancel, not the window-level confirm path.
      if (this._confirm && this._confirm.hasAttribute('data-open')) {
        if (e.key === 'Escape') {
          this._closeConfirm();
          e.preventDefault();
        }
        return;
      }
      if (e.key === 'Escape' && this._menu && this._menu.hasAttribute('data-open')) {
        this._closeMenu();
        e.preventDefault();
        return;
      }
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      const key = e.key;
      let handled = true;
      if (key === 'ArrowRight' || key === 'PageDown' || key === ' ' || key === 'Spacebar') {
        this._advance(1, 'keyboard');
      } else if (key === 'ArrowLeft' || key === 'PageUp') {
        this._advance(-1, 'keyboard');
      } else if (key === 'Home') {
        this._go(0, 'keyboard');
      } else if (key === 'End') {
        this._go(this._slides.length - 1, 'keyboard');
      } else if (key === 'r' || key === 'R') {
        this._go(0, 'keyboard');
      } else if (/^[0-9]$/.test(key)) {
        // 1..9 jump to that slide; 0 jumps to 10.
        const n = key === '0' ? 9 : parseInt(key, 10) - 1;
        if (n < this._slides.length) this._go(n, 'keyboard');
      } else {
        handled = false;
      }
      if (handled) {
        e.preventDefault();
        this._flashOverlay();
      }
    }
    _go(i, reason = 'api') {
      if (!this._slides.length) return;
      const clamped = Math.max(0, Math.min(this._slides.length - 1, i));
      if (clamped === this._index) {
        this._flashOverlay();
        return;
      }
      this._index = clamped;
      this._applyIndex({
        showOverlay: true,
        broadcast: true,
        reason
      });
    }

    /** Step forward/back skipping any slide marked data-deck-skip. Falls
     *  back to _go's clamp-at-ends behaviour (flash overlay) when there's
     *  nothing further in that direction. */
    _advance(dir, reason) {
      if (!this._slides.length) return;
      let i = this._index + dir;
      while (i >= 0 && i < this._slides.length && this._slides[i].hasAttribute('data-deck-skip')) {
        i += dir;
      }
      if (i < 0 || i >= this._slides.length) {
        this._flashOverlay();
        return;
      }
      this._go(i, reason);
    }

    // ── Thumbnail rail ────────────────────────────────────────────────────
    //
    // Thumbs are keyed by slide element and reused across _renderRail()
    // calls, so a reorder/delete is an O(changed) DOM shuffle instead of an
    // O(N) teardown-and-re-clone. Each thumb starts as a lightweight shell
    // (num + empty frame); the clone is materialized lazily by an
    // IntersectionObserver when the frame scrolls into (or near) view, so
    // only visible-ish slides pay the clone + image-decode cost.

    _renderRail() {
      if (!this._rail || !this._railEnabled) {
        this._thumbs = [];
        return;
      }
      // FLIP: record each *materialized* thumb's top before the reconcile.
      // Off-screen (non-materialized) thumbs don't need the animation and
      // skipping their getBoundingClientRect saves a forced layout per
      // off-screen thumb on large decks.
      const prevTops = new Map();
      (this._thumbs || []).forEach(({
        thumb,
        slide,
        host
      }) => {
        if (host) prevTops.set(slide, thumb.getBoundingClientRect().top);
      });
      const st = this._rail.scrollTop;

      // Reconcile: reuse thumbs that already exist for a slide, create
      // shells for new slides, drop thumbs for removed slides.
      const bySlide = new Map();
      (this._thumbs || []).forEach(t => bySlide.set(t.slide, t));
      const next = [];
      this._slides.forEach(slide => {
        let t = bySlide.get(slide);
        if (t) bySlide.delete(slide);else t = this._makeThumb(slide);
        next.push(t);
      });
      // Orphans — slides removed since last render.
      bySlide.forEach(t => {
        if (this._railObserver) this._railObserver.unobserve(t.frame);
        t.thumb.remove();
      });
      // Put thumbs into document order to match _slides. insertBefore on
      // an already-correctly-placed node is a no-op, so this is cheap
      // when nothing moved.
      next.forEach((t, i) => {
        const want = t.thumb;
        const at = this._rail.children[i];
        if (at !== want) this._rail.insertBefore(want, at || null);
        t.i = i;
        t.num.textContent = String(i + 1);
        if (t.slide.hasAttribute('data-deck-skip')) t.thumb.setAttribute('data-skip', '');else t.thumb.removeAttribute('data-skip');
      });
      this._thumbs = next;
      this._rail.scrollTop = st;
      if (prevTops.size) {
        const moved = [];
        this._thumbs.forEach(({
          thumb,
          slide
        }) => {
          const old = prevTops.get(slide);
          if (old == null) return;
          const dy = old - thumb.getBoundingClientRect().top;
          if (Math.abs(dy) < 1) return;
          thumb.style.transition = 'none';
          thumb.style.transform = `translateY(${dy}px)`;
          moved.push(thumb);
        });
        if (moved.length) {
          // Commit the inverted positions before flipping the transition
          // on — otherwise the browser coalesces both style writes and
          // nothing animates.
          void this._rail.offsetHeight;
          moved.forEach(t => {
            t.style.transition = 'transform 180ms cubic-bezier(.2,.7,.3,1)';
            t.style.transform = '';
          });
          setTimeout(() => moved.forEach(t => {
            t.style.transition = '';
          }), 220);
        }
      }
      requestAnimationFrame(() => this._scaleThumbs());
      this._syncRail(false);
    }

    /** Create a lightweight thumb shell for one slide. The clone is
     *  materialized later by the IntersectionObserver. Event handlers
     *  look up the thumb's *current* index (via _thumbs.indexOf) so the
     *  same element can be reused across reorders. */
    _makeThumb(slide) {
      const thumb = document.createElement('div');
      thumb.className = 'thumb';
      thumb.tabIndex = 0;
      const num = document.createElement('div');
      num.className = 'num';
      const frame = document.createElement('div');
      frame.className = 'frame';
      thumb.append(num, frame);
      const entry = {
        thumb,
        num,
        frame,
        slide,
        clone: null,
        host: null,
        i: -1
      };
      // entry.i is refreshed on every _renderRail reconcile pass, so
      // handlers read the thumb's current position without an O(N) scan.
      const idx = () => entry.i;
      thumb.addEventListener('click', () => this._go(idx(), 'click'));
      // ↑/↓ step through the rail when a thumb has focus. _go clamps at the
      // ends and _applyIndex→_syncRail scrolls the new current thumb into
      // view; we move focus to it (preventScroll — _syncRail already
      // scrolled) so a held key walks the whole list. stopPropagation keeps
      // this out of the window-level _onKey nav handler.
      thumb.addEventListener('keydown', e => {
        if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        if (e.metaKey || e.ctrlKey || e.altKey) return;
        e.preventDefault();
        e.stopPropagation();
        this._go(idx() + (e.key === 'ArrowDown' ? 1 : -1), 'keyboard');
        const cur = this._thumbs && this._thumbs[this._index];
        if (cur) cur.thumb.focus({
          preventScroll: true
        });
      });
      thumb.addEventListener('contextmenu', e => {
        e.preventDefault();
        this._openMenu(idx(), e.clientX, e.clientY);
      });
      thumb.draggable = true;
      thumb.addEventListener('dragstart', e => {
        this._dragFrom = idx();
        thumb.setAttribute('data-dragging', '');
        e.dataTransfer.effectAllowed = 'move';
        try {
          e.dataTransfer.setData('text/plain', String(this._dragFrom));
        } catch (err) {}
      });
      thumb.addEventListener('dragend', () => {
        thumb.removeAttribute('data-dragging');
        this._clearDrop();
        this._dragFrom = null;
      });
      thumb.addEventListener('dragover', e => {
        if (this._dragFrom == null) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        const r = thumb.getBoundingClientRect();
        this._setDrop(idx(), e.clientY < r.top + r.height / 2 ? 'before' : 'after');
      });
      thumb.addEventListener('drop', e => {
        if (this._dragFrom == null) return;
        e.preventDefault();
        const i = idx();
        const r = thumb.getBoundingClientRect();
        let to = e.clientY >= r.top + r.height / 2 ? i + 1 : i;
        if (this._dragFrom < to) to--;
        const from = this._dragFrom;
        this._clearDrop();
        this._dragFrom = null;
        if (to !== from) this._moveSlide(from, to);
      });
      if (this._railObserver) this._railObserver.observe(frame);
      frame.__deckThumb = entry;
      return entry;
    }

    /** Lazily build the clone for a thumb that has scrolled into view. */
    _materialize(entry) {
      if (entry.host) return;
      const dw = this.designWidth,
        dh = this.designHeight;
      let clone = entry.slide.cloneNode(true);
      clone.removeAttribute('id');
      clone.removeAttribute('data-deck-active');
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      // Neuter heavy media; replace <video> with its poster so the box
      // keeps a visual. <iframe>/<audio> become empty placeholders.
      clone.querySelectorAll('iframe, audio, object, embed').forEach(el => {
        el.removeAttribute('src');
        el.removeAttribute('srcdoc');
        el.removeAttribute('data');
        el.innerHTML = '';
      });
      clone.querySelectorAll('video').forEach(el => {
        if (!el.poster) {
          el.removeAttribute('src');
          el.innerHTML = '';
          return;
        }
        const img = document.createElement('img');
        img.src = el.poster;
        img.alt = '';
        img.style.cssText = el.style.cssText + ';object-fit:cover;width:100%;height:100%;';
        img.className = el.className;
        el.replaceWith(img);
      });
      // Images: defer decode and let the browser pick the smallest
      // srcset candidate for the ~140px thumb. Same-URL clones reuse the
      // slide's decoded bitmap (URL-keyed cache), so the remaining cost
      // is paint/composite — lazy+async keeps that off the main thread.
      clone.querySelectorAll('img').forEach(el => {
        el.loading = 'lazy';
        el.decoding = 'async';
        if (el.srcset) el.sizes = (this._railPx || 188) + 'px';
      });
      // Custom elements inside the slide would have their
      // connectedCallback fire when the clone is appended. Replace them
      // with inert boxes so a component-heavy deck doesn't run N copies
      // of each component's mount logic in the rail. Children are
      // preserved so layout-wrapper elements (<my-column><h2>…</h2>)
      // still show their authored content; the querySelectorAll NodeList
      // is static, so nested custom elements in the moved subtree are
      // still visited on later iterations.
      const neuter = el => {
        const box = document.createElement('div');
        box.style.cssText = (el.getAttribute('style') || '') + ';background:rgba(0,0,0,0.06);border:1px dashed rgba(0,0,0,0.15);';
        box.className = el.className;
        // Preserve theming/i18n hooks so [data-*] / :lang() / [dir]
        // descendant selectors still match the neutered root.
        for (const a of el.attributes) {
          const n = a.name;
          if (n.startsWith('data-') || n.startsWith('aria-') || n === 'lang' || n === 'dir' || n === 'role' || n === 'title') {
            box.setAttribute(n, a.value);
          }
        }
        while (el.firstChild) box.appendChild(el.firstChild);
        return box;
      };
      // querySelectorAll('*') returns descendants only — a custom-element
      // slide root (<my-slide>…</my-slide>) would slip through and upgrade
      // on append. Swap the root first.
      if (clone.tagName.includes('-')) clone = neuter(clone);
      clone.querySelectorAll('*').forEach(el => {
        if (el.tagName.includes('-')) el.replaceWith(neuter(el));
      });
      clone.style.cssText += ';position:absolute;top:0;left:0;transform-origin:0 0;' + 'pointer-events:none;width:' + dw + 'px;height:' + dh + 'px;' + 'box-sizing:border-box;overflow:hidden;visibility:visible;opacity:1;';
      const host = document.createElement('div');
      host.style.cssText = 'position:absolute;inset:0;';
      this._syncThumbHostAttrs(host);
      const sr = host.attachShadow({
        mode: 'open'
      });
      if (this._adoptedSheet) sr.adoptedStyleSheets = [this._adoptedSheet];else {
        const st = document.createElement('style');
        st.textContent = this._authorCss || '';
        sr.appendChild(st);
      }
      sr.appendChild(clone);
      entry.frame.appendChild(host);
      entry.host = host;
      entry.clone = clone;
      if (this._thumbScale) clone.style.transform = 'scale(' + this._thumbScale + ')';
      // Once materialized the IO callback is a no-op early-return —
      // unobserve so scroll doesn't keep firing it.
      if (this._railObserver) this._railObserver.unobserve(entry.frame);
    }

    /** Re-clone a single thumb (live-update path). No-op if the thumb
     *  hasn't been materialized yet — it'll pick up current content when
     *  it scrolls into view. */
    _refreshThumb(slide) {
      const entry = (this._thumbs || []).find(t => t.slide === slide);
      if (!entry || !entry.host) return;
      entry.host.remove();
      entry.host = entry.clone = null;
      this._materialize(entry);
    }
    _scaleThumbs() {
      if (!this._thumbs || !this._thumbs.length) return;
      // Every frame is the same width; if it reads 0 the rail is
      // display:none (noscale / no-rail / presenting / print) — leave the
      // clones as-is and re-run when the rail is revealed.
      const fw = this._thumbs[0].frame.offsetWidth;
      if (!fw) return;
      this._thumbScale = fw / this.designWidth;
      this._thumbs.forEach(({
        clone
      }) => {
        if (clone) clone.style.transform = 'scale(' + this._thumbScale + ')';
      });
    }
    _setDrop(i, where) {
      // dragover fires at pointer-event rate; touch only the previous
      // and new target rather than sweeping all N thumbs.
      const t = this._thumbs && this._thumbs[i];
      if (this._dropOn && this._dropOn !== t) {
        this._dropOn.thumb.removeAttribute('data-drop');
      }
      if (t) t.thumb.setAttribute('data-drop', where);
      this._dropOn = t || null;
    }
    _clearDrop() {
      if (this._dropOn) this._dropOn.thumb.removeAttribute('data-drop');
      this._dropOn = null;
    }
    _syncRail(follow) {
      if (!this._thumbs) return;
      this._thumbs.forEach(({
        thumb
      }, i) => {
        if (i === this._index) {
          thumb.setAttribute('data-current', '');
          if (follow && typeof thumb.scrollIntoView === 'function') {
            thumb.scrollIntoView({
              block: 'nearest'
            });
          }
        } else {
          thumb.removeAttribute('data-current');
        }
      });
    }
    _openMenu(i, x, y) {
      if (!this._menu) return;
      this._menuIndex = i;
      const slide = this._slides[i];
      const skip = slide && slide.hasAttribute('data-deck-skip');
      this._menu.querySelector('[data-act="skip"]').textContent = skip ? 'Unskip slide' : 'Skip slide';
      this._menu.querySelector('[data-act="up"]').disabled = i <= 0;
      this._menu.querySelector('[data-act="down"]').disabled = i >= this._slides.length - 1;
      this._menu.querySelector('[data-act="delete"]').disabled = this._slides.length <= 1;
      // Place, then clamp to viewport after it's measurable.
      this._menu.style.left = x + 'px';
      this._menu.style.top = y + 'px';
      this._menu.setAttribute('data-open', '');
      const r = this._menu.getBoundingClientRect();
      const nx = Math.min(x, window.innerWidth - r.width - 4);
      const ny = Math.min(y, window.innerHeight - r.height - 4);
      this._menu.style.left = Math.max(4, nx) + 'px';
      this._menu.style.top = Math.max(4, ny) + 'px';
    }
    _closeMenu() {
      if (this._menu) this._menu.removeAttribute('data-open');
      this._menuIndex = -1;
    }
    _openConfirm(i) {
      if (!this._confirm) return;
      this._confirmIndex = i;
      this._confirm.querySelector('.title').textContent = 'Delete slide ' + (i + 1) + '?';
      this._confirm.setAttribute('data-open', '');
      const btn = this._confirm.querySelector('.danger');
      if (btn && btn.focus) btn.focus();
    }
    _closeConfirm() {
      if (this._confirm) this._confirm.removeAttribute('data-open');
      this._confirmIndex = -1;
    }
    _emitDeckChange(detail) {
      this.dispatchEvent(new CustomEvent('deckchange', {
        detail,
        bubbles: true,
        composed: true
      }));
    }
    _deleteSlide(i) {
      const slide = this._slides[i];
      if (!slide || this._slides.length <= 1) return;
      const wasCurrent = i === this._index;
      if (i < this._index || wasCurrent && i === this._slides.length - 1) this._index--;
      this._squelchSlotChange = true;
      slide.remove();
      this._emitDeckChange({
        action: 'delete',
        from: i,
        slide
      });
      this._collectSlides();
      this._applyIndex({
        showOverlay: true,
        broadcast: true,
        reason: 'mutation'
      });
    }
    _toggleSkip(i) {
      const slide = this._slides[i];
      if (!slide) return;
      const on = !slide.hasAttribute('data-deck-skip');
      if (on) slide.setAttribute('data-deck-skip', '');else slide.removeAttribute('data-deck-skip');
      if (this._thumbs && this._thumbs[i]) {
        if (on) this._thumbs[i].thumb.setAttribute('data-skip', '');else this._thumbs[i].thumb.removeAttribute('data-skip');
      }
      this._markLastVisible();
      this._emitDeckChange({
        action: on ? 'skip' : 'unskip',
        from: i,
        slide
      });
      // Re-broadcast so the presenter popup's prev/next thumbnails re-pick
      // the nearest non-skipped slide without waiting for a nav event.
      try {
        window.postMessage({
          slideIndexChanged: this._index,
          deckTotal: this._slides.length,
          deckSkipped: this._skippedIndices()
        }, '*');
      } catch (e) {}
    }
    _skippedIndices() {
      const out = [];
      for (let i = 0; i < this._slides.length; i++) {
        if (this._slides[i].hasAttribute('data-deck-skip')) out.push(i);
      }
      return out;
    }
    _moveSlide(i, j) {
      if (j < 0 || j >= this._slides.length || j === i) return;
      const slide = this._slides[i];
      const ref = j < i ? this._slides[j] : this._slides[j].nextSibling;
      // Track the active slide across the reorder so the same content
      // stays on screen.
      const cur = this._index;
      if (cur === i) this._index = j;else if (i < cur && j >= cur) this._index = cur - 1;else if (i > cur && j <= cur) this._index = cur + 1;
      this._squelchSlotChange = true;
      this.insertBefore(slide, ref);
      this._emitDeckChange({
        action: 'move',
        from: i,
        to: j,
        slide
      });
      this._collectSlides();
      this._applyIndex({
        showOverlay: false,
        broadcast: true,
        reason: 'mutation'
      });
    }

    // Public API ------------------------------------------------------------

    /** Current slide index (0-based). */
    get index() {
      return this._index;
    }
    /** Total slide count. */
    get length() {
      return this._slides.length;
    }
    /** Programmatically navigate. */
    goTo(i) {
      this._go(i, 'api');
    }
    next() {
      this._advance(1, 'api');
    }
    prev() {
      this._advance(-1, 'api');
    }
    reset() {
      this._go(0, 'api');
    }
  }
  if (!customElements.get('deck-stage')) {
    customElements.define('deck-stage', DeckStage);
  }
})();
})(); } catch (e) { __ds_ns.__errors.push({ path: "slides/deck-stage.js", error: String((e && e.message) || e) }); }

// ui_kits/website/App.jsx
try { (() => {
/* global React, Header, Hero, PromiseSection, CertBadges, LocationsMarquee, MissionFeature, PressStrip, InOnAroundSection, BrandGrid, BrandsPage, PartnerPage, Footer */
const {
  useEffect,
  useRef,
  useState
} = React;
function HomePage() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Hero, {
    setRoute: window.__setRoute
  }), /*#__PURE__*/React.createElement(PromiseSection, null), /*#__PURE__*/React.createElement(CertBadges, null), /*#__PURE__*/React.createElement(LocationsMarquee, null), /*#__PURE__*/React.createElement(MissionFeature, null), /*#__PURE__*/React.createElement(InOnAroundSection, null), /*#__PURE__*/React.createElement(BrandGrid, null), /*#__PURE__*/React.createElement(PressStrip, null));
}
Object.assign(window, {
  HomePage
});
function PlaceholderPage({
  title,
  kicker
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '240px 56px 200px',
      textAlign: 'center',
      background: 'var(--sb-ivory)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: 'Inter',
      fontWeight: 700,
      fontSize: 12,
      letterSpacing: '0.28em',
      textTransform: 'uppercase',
      color: 'var(--sb-plant)',
      margin: 0
    }
  }, kicker), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontFamily: 'Recoleta, Recoleta Alt, serif',
      fontWeight: 300,
      fontSize: 'clamp(56px, 7vw, 120px)',
      lineHeight: 1,
      letterSpacing: '-0.025em',
      margin: '32px 0 32px',
      color: 'var(--sb-soil)'
    }
  }, title), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: 'Inter',
      fontSize: 18,
      color: 'var(--sb-soil)',
      opacity: 0.7,
      maxWidth: 580,
      margin: '0 auto',
      lineHeight: 1.6
    }
  }, "Page intentionally minimal in this UI kit recreation. The visual treatment matches the Section divider slide template."));
}
function App() {
  const [route, setRoute] = useState('home');
  const [scrolled, setScrolled] = useState(false);
  const scrollerRef = useRef(null);

  // Expose setter globally so Hero can navigate
  window.__setRoute = r => {
    setRoute(r);
    scrollerRef.current?.scrollTo({
      top: 0,
      behavior: 'instant'
    });
  };
  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;
    const onScroll = () => setScrolled(el.scrollTop > 80);
    el.addEventListener('scroll', onScroll);
    return () => el.removeEventListener('scroll', onScroll);
  }, []);

  // Reset scroll when route changes
  useEffect(() => {
    scrollerRef.current?.scrollTo({
      top: 0,
      behavior: 'instant'
    });
    setScrolled(false);
  }, [route]);
  const body = route === 'home' ? /*#__PURE__*/React.createElement(HomePage, null) : route === 'brands' ? /*#__PURE__*/React.createElement(BrandsPage, null) : route === 'partner' ? /*#__PURE__*/React.createElement(PartnerPage, null) : route === 'press' ? /*#__PURE__*/React.createElement(PlaceholderPage, {
    kicker: "Society Brands in the News",
    title: "Press"
  }) : route === 'blog' ? /*#__PURE__*/React.createElement(PlaceholderPage, {
    kicker: "Field Notes",
    title: "Blog"
  }) : route === 'team' ? /*#__PURE__*/React.createElement(PlaceholderPage, {
    kicker: "Our People",
    title: "Team"
  }) : /*#__PURE__*/React.createElement(HomePage, null);
  return /*#__PURE__*/React.createElement("div", {
    ref: scrollerRef,
    style: {
      height: '100vh',
      overflowY: 'auto',
      background: 'var(--sb-ivory)',
      scrollBehavior: 'smooth'
    }
  }, /*#__PURE__*/React.createElement(Header, {
    route: route,
    setRoute: setRoute,
    scrolled: scrolled
  }), body, /*#__PURE__*/React.createElement(Footer, {
    setRoute: setRoute
  }));
}
Object.assign(window, {
  App
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/App.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/BrandCard.jsx
try { (() => {
/* global React */

const cardStyles = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    background: 'var(--sb-ivory)',
    borderTop: '1px solid rgba(56,40,37,0.12)',
    padding: '56px 0',
    gap: 28,
    cursor: 'pointer',
    transition: 'transform 320ms cubic-bezier(0.22,0.61,0.36,1)'
  },
  cardHover: {
    transform: 'translateY(-4px)'
  },
  number: {
    fontFamily: 'Inter',
    fontSize: 11,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    color: 'var(--sb-plant)',
    opacity: 0.7,
    fontWeight: 500
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gap: 64,
    alignItems: 'start'
  },
  imageWrap: {
    aspectRatio: '4/3',
    overflow: 'hidden',
    borderRadius: 2
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    transition: 'transform 600ms ease'
  },
  imageHover: {
    transform: 'scale(1.04)'
  },
  copy: {
    display: 'flex',
    flexDirection: 'column',
    gap: 22
  },
  name: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 300,
    fontSize: 'clamp(40px, 4.4vw, 72px)',
    lineHeight: 1,
    letterSpacing: '-0.02em',
    color: 'var(--sb-soil)',
    margin: 0,
    textWrap: 'balance'
  },
  desc: {
    fontFamily: 'Inter',
    fontSize: 17,
    lineHeight: 1.6,
    color: 'var(--sb-soil)',
    opacity: 0.75,
    margin: 0,
    maxWidth: 540
  },
  link: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: '0.22em',
    textTransform: 'uppercase',
    color: 'var(--sb-soil)',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 12,
    marginTop: 8
  },
  arrow: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    border: '1px solid currentColor',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};
function BrandCard({
  index,
  name,
  desc,
  image,
  url
}) {
  const [hover, setHover] = React.useState(false);
  return /*#__PURE__*/React.createElement("article", {
    style: {
      ...cardStyles.card,
      ...(hover ? cardStyles.cardHover : {})
    },
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false)
  }, /*#__PURE__*/React.createElement("span", {
    style: cardStyles.number
  }, String(index).padStart(2, '0'), " / 06"), /*#__PURE__*/React.createElement("div", {
    style: cardStyles.row
  }, /*#__PURE__*/React.createElement("div", {
    style: cardStyles.imageWrap
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: name,
    style: {
      ...cardStyles.image,
      ...(hover ? cardStyles.imageHover : {})
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: cardStyles.copy
  }, /*#__PURE__*/React.createElement("h3", {
    style: cardStyles.name
  }, name), /*#__PURE__*/React.createElement("p", {
    style: cardStyles.desc
  }, desc), /*#__PURE__*/React.createElement("a", {
    href: url || '#',
    style: cardStyles.link,
    onClick: e => e.preventDefault()
  }, "Visit brand", /*#__PURE__*/React.createElement("span", {
    style: cardStyles.arrow
  }, /*#__PURE__*/React.createElement("svg", {
    width: "11",
    height: "11",
    viewBox: "0 0 12 12",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "1.4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10 L10 2 M5 2 H10 V7",
    strokeLinecap: "square"
  })))))));
}
Object.assign(window, {
  BrandCard
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/BrandCard.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/BrandGrid.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* global React, BrandCard */

const brandGridStyles = {
  wrap: {
    background: 'var(--sb-ivory)',
    padding: '120px 56px 160px'
  },
  inner: {
    maxWidth: 1280,
    margin: '0 auto'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: 60,
    marginBottom: 56,
    paddingBottom: 32,
    borderBottom: '1px solid rgba(56,40,37,0.12)'
  },
  eyebrow: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    color: 'var(--sb-plant)',
    margin: 0
  },
  title: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 300,
    fontSize: 'clamp(48px, 6vw, 96px)',
    lineHeight: 1,
    letterSpacing: '-0.025em',
    margin: 0,
    color: 'var(--sb-soil)'
  },
  meta: {
    fontFamily: 'Inter',
    fontSize: 13,
    color: 'var(--sb-soil)',
    opacity: 0.65,
    letterSpacing: '0.08em',
    textAlign: 'right'
  }
};
const BRANDS = [{
  name: 'Crunchi',
  desc: 'Going beyond clean beauty standards — high-performance makeup and skincare with clinically proven, safe ingredients and sustainable packaging. EWG verified.',
  image: 'https://images.squarespace-cdn.com/content/v1/6799522b542ab50fdf2ab976/5a8568df-1a40-4579-8053-0ee6d655b75f/heroimage.jpg?format=1500w'
}, {
  name: 'Primal Life Organics',
  desc: 'Holistic well-being and toxin-free solutions for dental, skin, and body care — formulated with plant-based and organic ingredients.',
  image: 'https://images.squarespace-cdn.com/content/v1/6799522b542ab50fdf2ab976/f356fe92-de5f-4aac-860d-19bf0a65c7ef/heroimage2.jpg?format=1500w'
}, {
  name: 'Cleanomic',
  desc: 'Eco-friendly cleaning products that reduce plastic waste — gentle, water-soluble laundry detergent sheets redefine how you care for your home.',
  image: 'https://images.squarespace-cdn.com/content/v1/6799522b542ab50fdf2ab976/1cbb8fa9-65c7-42f1-8ed0-fc0a690b436b/cleanomic-society-brands.jpg?format=1500w'
}, {
  name: 'Club EarlyBird',
  desc: 'Your go-to morning beverage. Stable, clean energy throughout the day without the jitters — powered by natural caffeine and clean ingredients.',
  image: 'https://images.squarespace-cdn.com/content/v1/6799522b542ab50fdf2ab976/118baa91-a1d1-4819-b4bc-994785c5b549/Early-bird-morning-coctail_society-brands-4.jpg?format=1500w'
}, {
  name: 'Clarifion',
  desc: 'Committed to fresher, healthier air in every space — innovative, modern air purification powered by cutting-edge ionization technology.',
  image: 'https://images.squarespace-cdn.com/content/v1/6799522b542ab50fdf2ab976/10ba8125-08e6-4193-a42e-a6fe0506ebd7/Clarifion_society-brands-4.jpg?format=1500w'
}, {
  name: 'Vitality Now',
  desc: 'Developed by Dr. Sam Walters. Premium all-natural health and wellness supplements to support and improve quality of life at every stage.',
  image: 'https://images.squarespace-cdn.com/content/v1/6799522b542ab50fdf2ab976/955fd734-a999-49b9-8dc7-ba8d5ce5982a/youthful-brain-presentation2.png?format=1500w'
}];
function BrandGrid() {
  return /*#__PURE__*/React.createElement("section", {
    style: brandGridStyles.wrap
  }, /*#__PURE__*/React.createElement("div", {
    style: brandGridStyles.inner
  }, /*#__PURE__*/React.createElement("div", {
    style: brandGridStyles.header
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: brandGridStyles.eyebrow
  }, "The portfolio"), /*#__PURE__*/React.createElement("h2", {
    style: brandGridStyles.title
  }, "Our Brands")), /*#__PURE__*/React.createElement("div", {
    style: brandGridStyles.meta
  }, "Six brands \xB7 IN \xB7 ON \xB7 AROUND", /*#__PURE__*/React.createElement("br", null), "Acquired 2020\u20132024")), BRANDS.map((b, i) => /*#__PURE__*/React.createElement(BrandCard, _extends({
    key: b.name,
    index: i + 1
  }, b)))));
}
Object.assign(window, {
  BrandGrid
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/BrandGrid.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/BrandsPage.jsx
try { (() => {
/* global React, BrandGrid */

const brandsPageStyles = {
  hero: {
    background: 'var(--sb-plant)',
    color: 'var(--sb-ivory)',
    padding: '200px 56px 120px',
    textAlign: 'center'
  },
  eyebrow: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 14,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    opacity: 0.85,
    margin: 0
  },
  title: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 300,
    fontSize: 'clamp(64px, 8vw, 132px)',
    lineHeight: 0.98,
    letterSpacing: '-0.025em',
    margin: '32px 0 24px',
    textWrap: 'balance'
  },
  body: {
    fontFamily: 'Inter',
    fontSize: 18,
    lineHeight: 1.7,
    maxWidth: 720,
    margin: '0 auto',
    opacity: 0.85
  }
};
function BrandsPage() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", {
    style: brandsPageStyles.hero
  }, /*#__PURE__*/React.createElement("p", {
    style: brandsPageStyles.eyebrow
  }, "The Portfolio"), /*#__PURE__*/React.createElement("h1", {
    style: brandsPageStyles.title
  }, "Six brands.", /*#__PURE__*/React.createElement("br", null), "One framework."), /*#__PURE__*/React.createElement("p", {
    style: brandsPageStyles.body
  }, "A growing portfolio of health and personal care brands organized around what goes ", /*#__PURE__*/React.createElement("em", null, "in, on,"), " and ", /*#__PURE__*/React.createElement("em", null, "around"), " your body \u2014 selected for clean ingredients, mission alignment, and category leadership.")), /*#__PURE__*/React.createElement(BrandGrid, null));
}
Object.assign(window, {
  BrandsPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/BrandsPage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/CertBadges.jsx
try { (() => {
/* global React */

const certStyles = {
  wrap: {
    background: 'var(--sb-ivory)',
    padding: '0 56px 120px',
    color: 'var(--sb-soil)'
  },
  inner: {
    maxWidth: 1200,
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 96,
    flexWrap: 'wrap',
    paddingTop: 24,
    borderTop: '1px solid rgba(56,40,37,0.10)'
  },
  badge: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 14,
    padding: '32px 16px'
  },
  ring: {
    width: 84,
    height: 84,
    borderRadius: '50%',
    border: '1.5px solid var(--sb-plant)',
    color: 'var(--sb-plant)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  label: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 11,
    letterSpacing: '0.22em',
    textTransform: 'uppercase',
    color: 'var(--sb-soil)',
    textAlign: 'center',
    lineHeight: 1.5
  }
};
function CertBadges() {
  return /*#__PURE__*/React.createElement("section", {
    style: certStyles.wrap
  }, /*#__PURE__*/React.createElement("div", {
    style: certStyles.inner
  }, /*#__PURE__*/React.createElement("div", {
    style: certStyles.badge
  }, /*#__PURE__*/React.createElement("div", {
    style: certStyles.ring
  }, /*#__PURE__*/React.createElement("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c5 5 5 12 0 16-5-4-5-11 0-16zM8 11c-2.5 0-4-1.5-4-4 2.5 0 4 1.5 4 4zM16 11c2.5 0 4-1.5 4-4-2.5 0-4 1.5-4 4z"
  }))), /*#__PURE__*/React.createElement("div", {
    style: certStyles.label
  }, "Vegan", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: .55
    }
  }, "Cruelty-free"))), /*#__PURE__*/React.createElement("div", {
    style: certStyles.badge
  }, /*#__PURE__*/React.createElement("div", {
    style: certStyles.ring
  }, /*#__PURE__*/React.createElement("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6l12 12M9 9h.01M15 15h.01"
  }))), /*#__PURE__*/React.createElement("div", {
    style: certStyles.label
  }, "Gluten-", /*#__PURE__*/React.createElement("br", null), "Free")), /*#__PURE__*/React.createElement("div", {
    style: certStyles.badge
  }, /*#__PURE__*/React.createElement("div", {
    style: certStyles.ring
  }, /*#__PURE__*/React.createElement("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13l3 3 5-7"
  }))), /*#__PURE__*/React.createElement("div", {
    style: certStyles.label
  }, "Non-", /*#__PURE__*/React.createElement("br", null), "GMO"))));
}
Object.assign(window, {
  CertBadges
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/CertBadges.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Footer.jsx
try { (() => {
/* global React */

const footerStyles = {
  wrap: {
    background: 'var(--sb-plant)',
    color: 'var(--sb-ivory)',
    padding: '120px 56px 56px',
    position: 'relative',
    overflow: 'hidden'
  },
  inner: {
    maxWidth: 1440,
    margin: '0 auto',
    position: 'relative',
    zIndex: 2
  },
  hugeMark: {
    position: 'absolute',
    right: -120,
    bottom: -160,
    width: 720,
    opacity: 0.06,
    pointerEvents: 'none'
  },
  topRow: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr',
    gap: 48,
    marginBottom: 96,
    alignItems: 'start'
  },
  brandCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: 28
  },
  wordmark: {
    height: 30,
    alignSelf: 'flex-start'
  },
  tagline: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 300,
    fontSize: 28,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
    maxWidth: 420,
    margin: 0
  },
  socials: {
    display: 'flex',
    gap: 12,
    marginTop: 8
  },
  socialBtn: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    border: '1px solid currentColor',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    color: 'inherit',
    opacity: 0.9
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    gap: 18
  },
  colLabel: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 11,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    opacity: 0.6,
    margin: 0
  },
  link: {
    fontFamily: 'Inter',
    fontSize: 15,
    color: 'inherit',
    textDecoration: 'none',
    opacity: 0.92,
    lineHeight: 1.4
  },
  divider: {
    height: 1,
    background: 'currentColor',
    opacity: 0.2,
    margin: '40px 0 32px'
  },
  bottomRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 24,
    flexWrap: 'wrap'
  },
  fineLinks: {
    display: 'flex',
    gap: 28,
    flexWrap: 'wrap'
  },
  fineLink: {
    fontFamily: 'Inter',
    fontSize: 12,
    color: 'inherit',
    opacity: 0.7,
    textDecoration: 'none'
  },
  copyright: {
    fontFamily: 'Inter',
    fontSize: 12,
    opacity: 0.7,
    letterSpacing: '0.04em'
  }
};
function FooterSocialIcon({
  name
}) {
  if (name === 'instagram') return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "6.5",
    r: "0.8",
    fill: "currentColor"
  }));
  if (name === 'facebook') return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 22v-8h3l.5-4H13V7.5c0-1.1.3-1.8 1.9-1.8H17V2.1c-.3 0-1.5-.1-2.9-.1-2.9 0-4.9 1.8-4.9 5v2.8H6v4h3.2V22H13z"
  }));
  return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM8 17H5.5v-7H8v7zM6.7 8.7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM18 17h-2.5v-3.7c0-.9-.3-1.5-1.1-1.5-.6 0-1 .4-1.2 1-.1.2-.1.4-.1.7V17H10.7s.1-6.4 0-7h2.5v1c.3-.5 1-1.2 2.3-1.2 1.7 0 2.9 1.1 2.9 3.4V17z"
  }));
}
function Footer({
  setRoute
}) {
  return /*#__PURE__*/React.createElement("footer", {
    style: footerStyles.wrap
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/logos/submark-ivory-on-plant.png",
    alt: "",
    style: footerStyles.hugeMark
  }), /*#__PURE__*/React.createElement("div", {
    style: footerStyles.inner
  }, /*#__PURE__*/React.createElement("div", {
    style: footerStyles.topRow
  }, /*#__PURE__*/React.createElement("div", {
    style: footerStyles.brandCol
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/logos/wordmark-ivory.png",
    alt: "society brands",
    style: footerStyles.wordmark
  }), /*#__PURE__*/React.createElement("p", {
    style: footerStyles.tagline
  }, "Clean & toxin-free products in, on, and around your body."), /*#__PURE__*/React.createElement("div", {
    style: footerStyles.socials
  }, /*#__PURE__*/React.createElement("a", {
    style: footerStyles.socialBtn,
    href: "#",
    onClick: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement(FooterSocialIcon, {
    name: "instagram"
  })), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.socialBtn,
    href: "#",
    onClick: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement(FooterSocialIcon, {
    name: "facebook"
  })), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.socialBtn,
    href: "#",
    onClick: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement(FooterSocialIcon, {
    name: "linkedin"
  })))), /*#__PURE__*/React.createElement("div", {
    style: footerStyles.col
  }, /*#__PURE__*/React.createElement("p", {
    style: footerStyles.colLabel
  }, "Navigation"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => {
      e.preventDefault();
      setRoute('home');
    }
  }, "Home"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => {
      e.preventDefault();
      setRoute('brands');
    }
  }, "Our Brands"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => {
      e.preventDefault();
      setRoute('partner');
    }
  }, "Partner"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => {
      e.preventDefault();
      setRoute('press');
    }
  }, "Press"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => e.preventDefault()
  }, "Contact")), /*#__PURE__*/React.createElement("div", {
    style: footerStyles.col
  }, /*#__PURE__*/React.createElement("p", {
    style: footerStyles.colLabel
  }, "Our Brands"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => e.preventDefault()
  }, "Crunchi"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => e.preventDefault()
  }, "Primal Life Organics"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => e.preventDefault()
  }, "Cleanomic"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => e.preventDefault()
  }, "Club EarlyBird"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => e.preventDefault()
  }, "Clarifion"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.link,
    href: "#",
    onClick: e => e.preventDefault()
  }, "Vitality Now")), /*#__PURE__*/React.createElement("div", {
    style: footerStyles.col
  }, /*#__PURE__*/React.createElement("p", {
    style: footerStyles.colLabel
  }, "Stay in touch"), /*#__PURE__*/React.createElement("p", {
    style: {
      ...footerStyles.link,
      opacity: 0.78,
      lineHeight: 1.55
    }
  }, "News, product launches, and the occasional field note from the team."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      borderBottom: '1px solid currentColor',
      paddingBottom: 6,
      marginTop: 4
    }
  }, /*#__PURE__*/React.createElement("input", {
    placeholder: "you@domain.com",
    style: {
      flex: 1,
      background: 'transparent',
      border: 0,
      color: 'inherit',
      outline: 'none',
      fontFamily: 'Inter',
      fontSize: 14
    }
  }), /*#__PURE__*/React.createElement("button", {
    style: {
      background: 'transparent',
      border: 0,
      color: 'inherit',
      cursor: 'pointer',
      fontFamily: 'Inter',
      fontWeight: 700,
      fontSize: 11,
      letterSpacing: '0.22em',
      textTransform: 'uppercase'
    }
  }, "Join \u2192")))), /*#__PURE__*/React.createElement("div", {
    style: footerStyles.divider
  }), /*#__PURE__*/React.createElement("div", {
    style: footerStyles.bottomRow
  }, /*#__PURE__*/React.createElement("span", {
    style: footerStyles.copyright
  }, "Society Brands \xA9 2025 \xB7 All Rights Reserved"), /*#__PURE__*/React.createElement("div", {
    style: footerStyles.fineLinks
  }, /*#__PURE__*/React.createElement("a", {
    style: footerStyles.fineLink,
    href: "#",
    onClick: e => e.preventDefault()
  }, "Privacy Policy"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.fineLink,
    href: "#",
    onClick: e => e.preventDefault()
  }, "Terms & Conditions"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.fineLink,
    href: "#",
    onClick: e => e.preventDefault()
  }, "California Privacy"), /*#__PURE__*/React.createElement("a", {
    style: footerStyles.fineLink,
    href: "#",
    onClick: e => e.preventDefault()
  }, "Mobile TOS")))));
}
Object.assign(window, {
  Footer
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Footer.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Header.jsx
try { (() => {
/* global React */
const {
  useEffect,
  useState
} = React;
const headerStyles = {
  wrap: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    transition: 'background 320ms ease, color 320ms ease, border-color 320ms ease, padding 320ms ease',
    borderBottom: '1px solid transparent'
  },
  wrapTransparent: {
    background: 'transparent',
    color: 'var(--sb-ivory)'
  },
  wrapSolid: {
    background: 'var(--sb-ivory)',
    color: 'var(--sb-soil)',
    borderBottomColor: 'rgba(56,40,37,0.10)'
  },
  inner: {
    maxWidth: 1440,
    margin: '0 auto',
    padding: '20px 56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 40
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    cursor: 'pointer',
    textDecoration: 'none'
  },
  brandImg: {
    height: 28,
    display: 'block'
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: 36,
    fontFamily: 'Inter',
    fontSize: 13,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    fontWeight: 500
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',
    padding: '6px 0',
    cursor: 'pointer',
    borderBottom: '1px solid transparent',
    transition: 'border-color 200ms'
  },
  linkActive: {
    borderBottomColor: 'currentColor'
  },
  socials: {
    display: 'flex',
    gap: 14,
    alignItems: 'center'
  },
  socialBtn: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'currentColor',
    textDecoration: 'none',
    opacity: .85,
    border: '1px solid currentColor'
  }
};
function SocialIcon({
  name
}) {
  if (name === 'instagram') return /*#__PURE__*/React.createElement("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "6.5",
    r: "0.8",
    fill: "currentColor"
  }));
  if (name === 'facebook') return /*#__PURE__*/React.createElement("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 22v-8h3l.5-4H13V7.5c0-1.1.3-1.8 1.9-1.8H17V2.1c-.3 0-1.5-.1-2.9-.1-2.9 0-4.9 1.8-4.9 5v2.8H6v4h3.2V22H13z"
  }));
  return /*#__PURE__*/React.createElement("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM8 17H5.5v-7H8v7zM6.7 8.7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM18 17h-2.5v-3.7c0-.9-.3-1.5-1.1-1.5-.6 0-1 .4-1.2 1-.1.2-.1.4-.1.7V17H10.7s.1-6.4 0-7h2.5v1c.3-.5 1-1.2 2.3-1.2 1.7 0 2.9 1.1 2.9 3.4V17z"
  }));
}
function Header({
  route,
  setRoute,
  scrolled
}) {
  const mode = scrolled ? 'solid' : 'transparent';
  const items = [{
    id: 'home',
    label: 'Home'
  }, {
    id: 'brands',
    label: 'Brands'
  }, {
    id: 'press',
    label: 'Press'
  }, {
    id: 'blog',
    label: 'Blog'
  }, {
    id: 'partner',
    label: 'Partner'
  }, {
    id: 'team',
    label: 'Team'
  }];
  const logo = scrolled ? '../../assets/logos/wordmark-soil.png' : '../../assets/logos/wordmark-ivory.png';
  return /*#__PURE__*/React.createElement("header", {
    style: {
      ...headerStyles.wrap,
      ...(scrolled ? headerStyles.wrapSolid : headerStyles.wrapTransparent)
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: headerStyles.inner
  }, /*#__PURE__*/React.createElement("a", {
    style: headerStyles.brand,
    onClick: e => {
      e.preventDefault();
      setRoute('home');
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: "society brands",
    style: headerStyles.brandImg
  })), /*#__PURE__*/React.createElement("nav", {
    style: headerStyles.nav
  }, items.map(it => /*#__PURE__*/React.createElement("a", {
    key: it.id,
    style: {
      ...headerStyles.link,
      ...(route === it.id ? headerStyles.linkActive : {})
    },
    onClick: e => {
      e.preventDefault();
      setRoute(it.id);
    }
  }, it.label))), /*#__PURE__*/React.createElement("div", {
    style: headerStyles.socials
  }, /*#__PURE__*/React.createElement("a", {
    style: headerStyles.socialBtn,
    href: "#",
    onClick: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement(SocialIcon, {
    name: "instagram"
  })), /*#__PURE__*/React.createElement("a", {
    style: headerStyles.socialBtn,
    href: "#",
    onClick: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement(SocialIcon, {
    name: "facebook"
  })), /*#__PURE__*/React.createElement("a", {
    style: headerStyles.socialBtn,
    href: "#",
    onClick: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement(SocialIcon, {
    name: "linkedin"
  })))));
}
Object.assign(window, {
  Header
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Header.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Hero.jsx
try { (() => {
/* global React */

const heroStyles = {
  wrap: {
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    color: 'var(--sb-ivory)',
    background: 'var(--sb-plant)',
    paddingTop: 80
  },
  // layered nature ambiance
  bg: {
    position: 'absolute',
    inset: 0,
    backgroundImage: 'url(../../assets/imagery/water-sand-texture.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    filter: 'brightness(0.55) saturate(0.6)',
    mixBlendMode: 'multiply'
  },
  veil: {
    position: 'absolute',
    inset: 0,
    background: 'radial-gradient(ellipse at 50% 40%, rgba(56,40,37,0) 0%, rgba(56,40,37,0.35) 100%), linear-gradient(180deg, rgba(95,116,111,0.4) 0%, rgba(95,116,111,0.7) 100%)'
  },
  content: {
    position: 'relative',
    maxWidth: 1440,
    width: '100%',
    padding: '160px 56px 120px',
    textAlign: 'center',
    zIndex: 2
  },
  eyebrow: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 14,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    margin: 0,
    opacity: 0.9
  },
  rule: {
    width: 64,
    height: 1,
    background: 'currentColor',
    opacity: 0.6,
    margin: '32px auto'
  },
  title: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 300,
    fontSize: 'clamp(64px, 9vw, 156px)',
    lineHeight: 0.98,
    letterSpacing: '-0.025em',
    margin: 0,
    color: 'inherit',
    textWrap: 'balance'
  },
  ctaRow: {
    display: 'flex',
    gap: 18,
    justifyContent: 'center',
    marginTop: 64,
    flexWrap: 'wrap'
  },
  cta: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: '0.2em',
    textTransform: 'uppercase',
    padding: '18px 32px',
    borderRadius: 2,
    border: '1px solid var(--sb-ivory)',
    background: 'transparent',
    color: 'var(--sb-ivory)',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 12,
    transition: 'background 200ms, color 200ms'
  },
  ctaPrimary: {
    background: 'var(--sb-ivory)',
    color: 'var(--sb-soil)'
  },
  scrollHint: {
    position: 'absolute',
    bottom: 32,
    left: '50%',
    transform: 'translateX(-50%)',
    fontFamily: 'Inter',
    fontSize: 10,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    opacity: 0.7,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexDirection: 'column'
  },
  scrollLine: {
    width: 1,
    height: 40,
    background: 'currentColor',
    opacity: 0.6
  }
};
function HeroArrowIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10 L10 2 M5 2 H10 V7",
    strokeLinecap: "square"
  }));
}
function Hero({
  setRoute
}) {
  return /*#__PURE__*/React.createElement("section", {
    style: heroStyles.wrap
  }, /*#__PURE__*/React.createElement("div", {
    style: heroStyles.bg
  }), /*#__PURE__*/React.createElement("div", {
    style: heroStyles.veil
  }), /*#__PURE__*/React.createElement("div", {
    style: heroStyles.content
  }, /*#__PURE__*/React.createElement("p", {
    style: heroStyles.eyebrow
  }, "Clean and Toxin-Free Products"), /*#__PURE__*/React.createElement("div", {
    style: heroStyles.rule
  }), /*#__PURE__*/React.createElement("h1", {
    style: heroStyles.title
  }, "In, on, and around your body."), /*#__PURE__*/React.createElement("div", {
    style: heroStyles.ctaRow
  }, /*#__PURE__*/React.createElement("a", {
    style: {
      ...heroStyles.cta,
      ...heroStyles.ctaPrimary
    },
    onClick: e => {
      e.preventDefault();
      setRoute('brands');
    }
  }, "Discover our brands ", /*#__PURE__*/React.createElement(HeroArrowIcon, null)), /*#__PURE__*/React.createElement("a", {
    style: heroStyles.cta,
    onClick: e => {
      e.preventDefault();
      setRoute('partner');
    }
  }, "Sell your brand ", /*#__PURE__*/React.createElement(HeroArrowIcon, null)))), /*#__PURE__*/React.createElement("div", {
    style: heroStyles.scrollHint
  }, /*#__PURE__*/React.createElement("span", null, "Scroll"), /*#__PURE__*/React.createElement("div", {
    style: heroStyles.scrollLine
  })));
}
Object.assign(window, {
  Hero
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Hero.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/InOnAroundSection.jsx
try { (() => {
/* global React */

const ioaStyles = {
  wrap: {
    background: 'var(--sb-ivory)',
    padding: '160px 56px 140px',
    color: 'var(--sb-soil)'
  },
  inner: {
    maxWidth: 1280,
    margin: '0 auto'
  },
  header: {
    textAlign: 'center',
    marginBottom: 96
  },
  eyebrow: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    color: 'var(--sb-plant)',
    margin: '0 0 24px 0'
  },
  title: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 300,
    fontSize: 'clamp(40px, 5vw, 72px)',
    lineHeight: 1.05,
    letterSpacing: '-0.02em',
    margin: '0 auto',
    maxWidth: 900,
    textWrap: 'balance'
  },
  intro: {
    fontFamily: 'Inter',
    fontSize: 18,
    lineHeight: 1.6,
    maxWidth: 760,
    margin: '40px auto 0',
    color: 'var(--sb-soil)',
    opacity: 0.78
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 0,
    borderTop: '1px solid rgba(56,40,37,0.12)',
    borderBottom: '1px solid rgba(56,40,37,0.12)'
  },
  col: {
    padding: '64px 40px',
    borderRight: '1px solid rgba(56,40,37,0.12)',
    display: 'flex',
    flexDirection: 'column',
    gap: 32
  },
  colLast: {
    borderRight: 'none'
  },
  bigWord: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 400,
    fontSize: 88,
    lineHeight: 1,
    letterSpacing: '-0.02em',
    color: 'var(--sb-plant)',
    margin: 0
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 14
  },
  item: {
    fontFamily: 'Inter',
    fontSize: 17,
    color: 'var(--sb-soil)',
    lineHeight: 1.4,
    paddingBottom: 14,
    borderBottom: '1px solid rgba(56,40,37,0.08)'
  }
};
function Column({
  word,
  items,
  last
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      ...ioaStyles.col,
      ...(last ? ioaStyles.colLast : {})
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: ioaStyles.bigWord
  }, word), /*#__PURE__*/React.createElement("ul", {
    style: ioaStyles.list
  }, items.map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: ioaStyles.item
  }, t))));
}
function InOnAroundSection() {
  return /*#__PURE__*/React.createElement("section", {
    style: ioaStyles.wrap
  }, /*#__PURE__*/React.createElement("div", {
    style: ioaStyles.inner
  }, /*#__PURE__*/React.createElement("div", {
    style: ioaStyles.header
  }, /*#__PURE__*/React.createElement("p", {
    style: ioaStyles.eyebrow
  }, "Healthy mind, body, and home"), /*#__PURE__*/React.createElement("h2", {
    style: ioaStyles.title
  }, "Products that make a profound difference."), /*#__PURE__*/React.createElement("p", {
    style: ioaStyles.intro
  }, "We're building a portfolio of health and personal care brands that fit within a simple but powerful framework \u2014 ", /*#__PURE__*/React.createElement("em", {
    style: {
      color: 'var(--sb-plant)'
    }
  }, "what goes IN, ON, and AROUND your body."), " From functional foods and skincare to air and home care, we create a marketplace of trusted brands that enhance everyday life.")), /*#__PURE__*/React.createElement("div", {
    style: ioaStyles.grid
  }, /*#__PURE__*/React.createElement(Column, {
    word: "IN",
    items: ['Functional Foods', 'Natural Remedies', 'Dietary Supplements', 'Food and Beverage']
  }), /*#__PURE__*/React.createElement(Column, {
    word: "ON",
    items: ['Skincare', 'Personal Care Cosmetics', 'Hair Care', 'Baby and Kids Care']
  }), /*#__PURE__*/React.createElement(Column, {
    word: "AROUND",
    items: ['Home Cleaning', 'Air Care', 'Household Essentials', 'Garden and Outdoor'],
    last: true
  }))));
}
Object.assign(window, {
  InOnAroundSection
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/InOnAroundSection.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/LocationsMarquee.jsx
try { (() => {
/* global React */

const marqueeStyles = {
  wrap: {
    background: 'var(--sb-plant)',
    color: 'var(--sb-ivory)',
    padding: '32px 0',
    overflow: 'hidden',
    position: 'relative'
  },
  track: {
    display: 'flex',
    gap: 64,
    whiteSpace: 'nowrap',
    animation: 'sb-marquee 40s linear infinite',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 16,
    letterSpacing: '0.22em',
    textTransform: 'uppercase'
  },
  item: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 64
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: 'currentColor',
    opacity: 0.5,
    display: 'inline-block'
  }
};
function LocationsMarquee() {
  const items = ['Canton, OH', 'Newport Beach, CA', 'Kalamazoo, MI', 'Founded in 2020'];
  // Duplicate for infinite scroll
  const all = [...items, ...items, ...items, ...items];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, `@keyframes sb-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`), /*#__PURE__*/React.createElement("div", {
    style: marqueeStyles.wrap
  }, /*#__PURE__*/React.createElement("div", {
    style: marqueeStyles.track
  }, all.map((s, i) => /*#__PURE__*/React.createElement("span", {
    key: i,
    style: marqueeStyles.item
  }, /*#__PURE__*/React.createElement("span", {
    style: marqueeStyles.dot
  }), s)))));
}
Object.assign(window, {
  LocationsMarquee
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/LocationsMarquee.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/MissionFeature.jsx
try { (() => {
/* global React */

const handsStyles = {
  wrap: {
    background: 'var(--sb-plant)',
    color: 'var(--sb-ivory)',
    overflow: 'hidden',
    position: 'relative'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    minHeight: 720,
    alignItems: 'stretch'
  },
  imageCol: {
    position: 'relative',
    overflow: 'hidden',
    minHeight: 600
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    filter: 'saturate(0.85)'
  },
  copyCol: {
    padding: '120px 80px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative'
  },
  submark: {
    position: 'absolute',
    right: 80,
    top: 80,
    width: 88,
    height: 88,
    opacity: 0.45
  },
  eyebrow: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    opacity: 0.85,
    margin: '0 0 32px 0'
  },
  title: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 300,
    fontSize: 'clamp(40px, 5vw, 72px)',
    lineHeight: 1.05,
    letterSpacing: '-0.02em',
    margin: '0 0 32px 0',
    textWrap: 'balance'
  },
  body: {
    fontFamily: 'Inter',
    fontSize: 17,
    lineHeight: 1.7,
    opacity: 0.85,
    maxWidth: 540,
    margin: 0
  },
  rule: {
    width: 56,
    height: 1,
    background: 'currentColor',
    opacity: 0.6,
    marginBottom: 32
  }
};
function MissionFeature() {
  return /*#__PURE__*/React.createElement("section", {
    style: handsStyles.wrap
  }, /*#__PURE__*/React.createElement("div", {
    style: handsStyles.grid
  }, /*#__PURE__*/React.createElement("div", {
    style: handsStyles.imageCol
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/imagery/hands-soap.jpg",
    alt: "Hands being washed gently",
    style: handsStyles.image
  })), /*#__PURE__*/React.createElement("div", {
    style: handsStyles.copyCol
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/logos/submark-ivory-on-plant.png",
    alt: "",
    style: handsStyles.submark
  }), /*#__PURE__*/React.createElement("p", {
    style: handsStyles.eyebrow
  }, "Our Mission"), /*#__PURE__*/React.createElement("div", {
    style: handsStyles.rule
  }), /*#__PURE__*/React.createElement("h2", {
    style: handsStyles.title
  }, "Revolutionize the way consumers experience wellness."), /*#__PURE__*/React.createElement("p", {
    style: handsStyles.body
  }, "We design and bring innovative solutions that are safe, effective, and chemical-free \u2014 empowering our customers to thrive in optimal health and wellness. Across functional foods, skincare, dental, air care, and home essentials, every brand in our portfolio holds itself to the same standard."))));
}
Object.assign(window, {
  MissionFeature
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/MissionFeature.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/PartnerPage.jsx
try { (() => {
/* global React */

const partnerStyles = {
  wrap: {
    background: 'var(--sb-ivory)',
    color: 'var(--sb-soil)'
  },
  hero: {
    background: 'var(--sb-soil)',
    color: 'var(--sb-ivory)',
    padding: '200px 56px 120px'
  },
  heroInner: {
    maxWidth: 1280,
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1.2fr 1fr',
    gap: 80,
    alignItems: 'end'
  },
  eyebrow: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    opacity: 0.8,
    margin: 0
  },
  title: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 300,
    fontSize: 'clamp(56px, 7vw, 120px)',
    lineHeight: 0.98,
    letterSpacing: '-0.025em',
    margin: '24px 0 0',
    textWrap: 'balance'
  },
  intro: {
    fontFamily: 'Inter',
    fontSize: 18,
    lineHeight: 1.7,
    opacity: 0.85,
    margin: 0
  },
  body: {
    padding: '120px 56px',
    maxWidth: 1280,
    margin: '0 auto'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 96
  },
  formCol: {
    padding: '0 0 0 0'
  },
  fieldset: {
    display: 'flex',
    flexDirection: 'column',
    gap: 28
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  label: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 11,
    letterSpacing: '0.20em',
    textTransform: 'uppercase',
    color: 'var(--sb-plant)'
  },
  input: {
    fontFamily: 'Inter',
    fontSize: 17,
    color: 'var(--sb-soil)',
    background: 'transparent',
    border: 0,
    borderBottom: '1px solid rgba(56,40,37,0.25)',
    padding: '10px 0 12px',
    outline: 'none'
  },
  textarea: {
    fontFamily: 'Inter',
    fontSize: 17,
    color: 'var(--sb-soil)',
    background: 'transparent',
    border: '1px solid rgba(56,40,37,0.18)',
    borderRadius: 2,
    padding: '14px 16px',
    outline: 'none',
    minHeight: 120,
    resize: 'vertical'
  },
  submit: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: '0.20em',
    textTransform: 'uppercase',
    padding: '18px 32px',
    borderRadius: 2,
    background: 'var(--sb-soil)',
    color: 'var(--sb-ivory)',
    border: 0,
    cursor: 'pointer',
    marginTop: 16,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 12,
    alignSelf: 'flex-start'
  },
  sideTitle: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 300,
    fontSize: 48,
    lineHeight: 1.1,
    letterSpacing: '-0.02em',
    margin: '0 0 32px',
    color: 'var(--sb-soil)'
  },
  bullet: {
    display: 'flex',
    gap: 20,
    padding: '24px 0',
    borderTop: '1px solid rgba(56,40,37,0.12)'
  },
  bnum: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 400,
    fontSize: 32,
    color: 'var(--sb-plant)',
    lineHeight: 1,
    minWidth: 56
  },
  btext: {
    fontFamily: 'Inter',
    fontSize: 16,
    lineHeight: 1.6,
    color: 'var(--sb-soil)',
    opacity: 0.8,
    margin: 0
  },
  bhead: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 13,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    color: 'var(--sb-soil)',
    margin: '0 0 6px'
  }
};
function PartnerPage() {
  return /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.wrap
  }, /*#__PURE__*/React.createElement("section", {
    style: partnerStyles.hero
  }, /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.heroInner
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: partnerStyles.eyebrow
  }, "Partner with Society Brands"), /*#__PURE__*/React.createElement("h1", {
    style: partnerStyles.title
  }, "Sell your brand to a steward, not an aggregator.")), /*#__PURE__*/React.createElement("p", {
    style: partnerStyles.intro
  }, "We acquire functional health and personal care brands \u2014 and run them. Every brand in our portfolio keeps its team, its mission, and its standards. Tell us about yours."))), /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.body
  }, /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.grid
  }, /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.formCol
  }, /*#__PURE__*/React.createElement("h2", {
    style: partnerStyles.sideTitle
  }, "Start the conversation."), /*#__PURE__*/React.createElement("form", {
    style: partnerStyles.fieldset,
    onSubmit: e => {
      e.preventDefault();
      alert("Thanks — we'll be in touch.");
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.field
  }, /*#__PURE__*/React.createElement("label", {
    style: partnerStyles.label
  }, "Your name"), /*#__PURE__*/React.createElement("input", {
    style: partnerStyles.input,
    placeholder: "First & last",
    defaultValue: ""
  })), /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.field
  }, /*#__PURE__*/React.createElement("label", {
    style: partnerStyles.label
  }, "Email"), /*#__PURE__*/React.createElement("input", {
    style: partnerStyles.input,
    type: "email",
    placeholder: "you@brand.com"
  })), /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.field
  }, /*#__PURE__*/React.createElement("label", {
    style: partnerStyles.label
  }, "Brand name"), /*#__PURE__*/React.createElement("input", {
    style: partnerStyles.input,
    placeholder: "Acme Naturals"
  })), /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.field
  }, /*#__PURE__*/React.createElement("label", {
    style: partnerStyles.label
  }, "Annual revenue (USD)"), /*#__PURE__*/React.createElement("input", {
    style: partnerStyles.input,
    placeholder: "$5\u201310M"
  })), /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.field
  }, /*#__PURE__*/React.createElement("label", {
    style: partnerStyles.label
  }, "Tell us about your brand"), /*#__PURE__*/React.createElement("textarea", {
    style: partnerStyles.textarea,
    placeholder: "Category, channels, what makes you different\u2026"
  })), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    style: partnerStyles.submit
  }, "Submit inquiry", /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "1.6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10 L10 2 M5 2 H10 V7",
    strokeLinecap: "square"
  }))))), /*#__PURE__*/React.createElement("aside", null, /*#__PURE__*/React.createElement("h2", {
    style: partnerStyles.sideTitle
  }, "What you can expect."), /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.bullet
  }, /*#__PURE__*/React.createElement("span", {
    style: partnerStyles.bnum
  }, "01"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: partnerStyles.bhead
  }, "An honest read in 7 days"), /*#__PURE__*/React.createElement("p", {
    style: partnerStyles.btext
  }, "We respond to every serious inquiry. No \"submit and wait.\""))), /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.bullet
  }, /*#__PURE__*/React.createElement("span", {
    style: partnerStyles.bnum
  }, "02"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: partnerStyles.bhead
  }, "Founders stay, if they want"), /*#__PURE__*/React.createElement("p", {
    style: partnerStyles.btext
  }, "Most of our brand teams continued post-acquisition. Some founders consult, others sail off \u2014 both are fine."))), /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.bullet
  }, /*#__PURE__*/React.createElement("span", {
    style: partnerStyles.bnum
  }, "03"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: partnerStyles.bhead
  }, "Operational lift, not extraction"), /*#__PURE__*/React.createElement("p", {
    style: partnerStyles.btext
  }, "Shared back-office, retail expansion, supply chain \u2014 we invest where the brand gets stronger."))), /*#__PURE__*/React.createElement("div", {
    style: partnerStyles.bullet
  }, /*#__PURE__*/React.createElement("span", {
    style: partnerStyles.bnum
  }, "04"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: partnerStyles.bhead
  }, "Mission alignment is a hard filter"), /*#__PURE__*/React.createElement("p", {
    style: partnerStyles.btext
  }, "Clean, toxin-free, and built to last \u2014 or it's not for us.")))))));
}
Object.assign(window, {
  PartnerPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/PartnerPage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/PressStrip.jsx
try { (() => {
/* global React */

const pressStyles = {
  wrap: {
    background: 'var(--sb-soil)',
    color: 'var(--sb-ivory)',
    padding: '64px 0',
    overflow: 'hidden'
  },
  inner: {
    maxWidth: 1280,
    margin: '0 auto',
    padding: '0 56px'
  },
  label: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 11,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    opacity: 0.55,
    margin: '0 0 32px 0'
  },
  track: {
    display: 'flex',
    gap: 80,
    alignItems: 'center',
    animation: 'sb-press-marquee 50s linear infinite',
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 400,
    fontSize: 28,
    whiteSpace: 'nowrap',
    opacity: 0.85
  },
  logo: {
    fontStyle: 'italic',
    opacity: 0.85
  }
};
function PressStrip() {
  const press = ['Forbes', 'Inc.', 'BusinessWire', 'TechCrunch', 'AdAge', 'Bloomberg', 'PR Newswire', 'Modern Retail', 'Glossy', 'Retail Brew', 'Yahoo Finance', 'CNBC'];
  const doubled = [...press, ...press, ...press];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, `@keyframes sb-press-marquee { from { transform: translateX(0); } to { transform: translateX(-33.333%); } }`), /*#__PURE__*/React.createElement("section", {
    style: pressStyles.wrap
  }, /*#__PURE__*/React.createElement("div", {
    style: pressStyles.inner
  }, /*#__PURE__*/React.createElement("p", {
    style: pressStyles.label
  }, "As featured in")), /*#__PURE__*/React.createElement("div", {
    style: pressStyles.track
  }, doubled.map((p, i) => /*#__PURE__*/React.createElement("span", {
    key: i,
    style: pressStyles.logo
  }, p)))));
}
Object.assign(window, {
  PressStrip
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/PressStrip.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/PromiseSection.jsx
try { (() => {
/* global React */

const promiseStyles = {
  wrap: {
    background: 'var(--sb-ivory)',
    padding: '160px 56px 140px',
    color: 'var(--sb-soil)'
  },
  inner: {
    maxWidth: 1200,
    margin: '0 auto',
    textAlign: 'center'
  },
  eyebrow: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    color: 'var(--sb-plant)',
    margin: '0 0 24px 0'
  },
  rule: {
    width: 56,
    height: 1,
    background: 'var(--sb-plant)',
    margin: '0 auto 48px'
  },
  quote: {
    fontFamily: 'Recoleta, Recoleta Alt, serif',
    fontWeight: 300,
    fontSize: 'clamp(28px, 3.2vw, 44px)',
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
    margin: 0,
    color: 'var(--sb-soil)',
    textWrap: 'pretty'
  },
  emph: {
    fontStyle: 'italic',
    color: 'var(--sb-plant)'
  }
};
function PromiseSection() {
  return /*#__PURE__*/React.createElement("section", {
    style: promiseStyles.wrap
  }, /*#__PURE__*/React.createElement("div", {
    style: promiseStyles.inner
  }, /*#__PURE__*/React.createElement("p", {
    style: promiseStyles.eyebrow
  }, "The Promise"), /*#__PURE__*/React.createElement("div", {
    style: promiseStyles.rule
  }), /*#__PURE__*/React.createElement("p", {
    style: promiseStyles.quote
  }, "We elevate, evolve, and empower brands to ", /*#__PURE__*/React.createElement("span", {
    style: promiseStyles.emph
  }, "do better"), " in offering safe, toxin-free products for use ", /*#__PURE__*/React.createElement("span", {
    style: promiseStyles.emph
  }, "in, on,"), " and ", /*#__PURE__*/React.createElement("span", {
    style: promiseStyles.emph
  }, "around"), " the body. We transform product portfolios to align with the highest standards of clean living \u2014 and ensure gentle, holistic solutions are more accessible to consumers.")));
}
Object.assign(window, {
  PromiseSection
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/PromiseSection.jsx", error: String((e && e.message) || e) }); }

__ds_ns.Badge = __ds_scope.Badge;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Card = __ds_scope.Card;

__ds_ns.SectionHeading = __ds_scope.SectionHeading;

})();
